import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar, Card, Modal, Alert, Collapse, Stack, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useOutletContext, useNavigate } from 'react-router-dom';
import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import {
    btnGold, btnGoldHover, FOCUS_GOLD, COLORS,
    header, footer, goldLinkBase, addUnderline, removeUnderline,
    boxshadowHover, boxshadowUnHover,
    showAdvancedBtn, searchBtn, uploadBtn, resetFiltersBtn, sourceDataBtn,
    statusColors, darkStatusColors,
    formLabel, columnTitle, columnSortLink, goldInputFocus, statusLabel,
    frame, goldFaPlus, faIconStyle,
    inputSm, paginationStyle, activePaginationStyle,
    dropDownToggle, dropDownMenu, tableRowHover, tableRowUnHover, stickyThStyle,
    filterActiveIndicator, 
} from '../styles/goldTheme.js'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut, apiPost } from "../services/AuthService.js";
import { BlockBlobClient } from "@azure/storage-blob";
import JSZip from "jszip";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCheck, faArrowUpLong, faArrowDownLong, faPencil, faBuilding, faCloudArrowUp, faFile, faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import Account from './Account';

//Drop edit
import { Dropdown, FormControl, Spinner } from "react-bootstrap";
import { bottom } from '@popperjs/core';
//import { current } from '@reduxjs/toolkit';



function NoDocConversionMessageModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h3>Document Conversion</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                <Container >
                    <Row>
                        <Col>
                            <h5
                                style={{
                                    marginBottom: '20px'
                                }}
                            >
                                Please contact support to activate the document conversion process - <a href="mailto:support@totdata.com">support@totdata.com</a>
                            </h5>
                            <h6
                                style={{
                                    fontSize: 15,
                                    fontStyle: "italic"
                                }}
                            >
                                TOTData offers instant EnergyLink PDF-to-XLS conversion for a fraction of what you're paying today. It's simple, accurate, and designed to save both time and budget.
                                No commitments or contracts, it's a pay-as-you-go model - only pay for what you use.  Try a statement on us, first one is free!
                            </h6>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'right'
                            }}
                        >
                            <Button
                                style={{
                                    ...btnGold
                                }}
                                onClick={props.onHide}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

function DocumentInputModal(props) {
    const fileInputRef = React.useRef(null);
    const ACCENT = '#C8B668';
    const sectionCard = {
        backgroundColor: '#ffffff',
        border: '1px solid #e9eef3',
        borderRadius: '14px',
        padding: '18px 20px',
        marginBottom: '16px',
        boxShadow: '0 1px 2px rgba(16,24,40,0.04)'
    };
    const sectionHeader = {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 600,
        fontSize: '0.95rem',
        color: '#0f172a',
        marginBottom: '14px'
    };
    const stepBadge = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '22px',
        height: '22px',
        borderRadius: '50%',
        backgroundColor: ACCENT,
        color: '#ffffff',
        fontWeight: 700,
        fontSize: '0.72rem',
        marginRight: '10px',
        flexShrink: 0
    };
    const dropZone = (dragging) => ({
        border: `2px dashed ${dragging ? ACCENT : '#cbd5e1'}`,
        borderRadius: '12px',
        backgroundColor: dragging ? '#fbf9ef' : '#fafbfc',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#64748b',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'border-color .15s ease, background-color .15s ease',
        padding: '16px'
    });
    const fileChip = {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        backgroundColor: '#ffffff',
        border: '1px solid #e9eef3',
        borderRadius: '10px',
        padding: '10px 12px',
        marginBottom: '8px',
        textAlign: 'left',
        boxShadow: '0 1px 2px rgba(16,24,40,0.04)'
    };
    const fileIcon = (name) => {
        const n = (name || '').toLowerCase();
        if (n.endsWith('.pdf')) return { icon: faFilePdf, color: '#e3342f' };
        if (n.endsWith('.xls') || n.endsWith('.xlsx')) return { icon: faFileExcel, color: '#1f9d55' };
        return { icon: faFile, color: '#64748b' };
    };
    const isImts = props.docConversionNetworkType === 1;
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Upload Documents</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '75vh', display: 'flex', flexDirection: 'column' }}>
                <Container className="d-flex flex-column" style={{ flex: 1, minHeight: 0 }}>
                    <p style={{ fontSize: '0.9rem', color: '#475569', marginBottom: '14px' }}>
                        {(props.docConversionNetworkType === 2 ?
                            "Convert any Revenue or JIB statement from PDF to XLS and/or CDEX." : "Convert any Revenue or JIB statement to XLS and/or CDEX.   We support .PDF, .TIF, .TIFF, .XLSX, .XLS.")}
                    </p>

                    {/* Section 1 — document details */}
                    <div style={sectionCard}>
                        <div style={sectionHeader}><span style={stepBadge}>1</span>Document Details</div>
                        <Form>
                            <Row className="g-3">
                                <Col md={isImts ? 4 : 6}>
                                    <Form.Group controlId="deliveryEmail">
                                        <Form.Label className="mb-1">Delivery Email</Form.Label>
                                        <Form.Control
                                            name="deliveryEmail"
                                            size="sm"
                                            aria-label="DeliveryEmail"
                                            value={props.newItemCriteria.deliveryEmail}
                                            placeholder="john.doe@gmail.com"
                                            onChange={props.handleInputChange}
                                            isInvalid={!props.isEmailValid}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a valid email.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                {isImts && (
                                    <Col md={3}>
                                        <Form.Group controlId="deliveryTimeId">
                                            <Form.Label className="mb-1">Delivery Time</Form.Label>
                                            <Form.Select
                                                name="deliveryTimeId"
                                                size="sm"
                                                value={props.newItemCriteria.deliveryTimeId}
                                                aria-label="Delivery Time"
                                                onChange={props.handleInputChange}
                                            >
                                                {props.deliveryTimes.map((time, i) => (
                                                    <option key={time.id} value={time.id}>
                                                        {time.time}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                )}
                                <Col md={isImts ? 5 : 6}>
                                    <Form.Group controlId="statementCategoryId">
                                        <Form.Label className="mb-1">Category/Org (optional)</Form.Label>
                                        <div className="d-flex">
                                            <Form.Select
                                                name="statementCategoryId"
                                                size="sm"
                                                value={props.newItemCriteria.statementCategoryId}
                                                aria-label="Org (optional)"
                                                onChange={props.handleInputChange}
                                            >
                                                {props.statementCategories.map((category, i) => (
                                                    <option key={category.id} value={category.id}>{category.code} {(category.name === '' ? '' : '-')} {category.name}</option>
                                                ))}
                                            </Form.Select>
                                            <Button
                                                size="sm"
                                                style={{ ...btnGold, fontSize: '.8rem', marginLeft: '8px', whiteSpace: 'nowrap' }}
                                                onClick={props.onAddCategory}
                                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                            >
                                                Add New
                                            </Button>
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                            {(() => {
                                if (props.docConversionNetworkType === 1) {
                                    return <Form.Group
                                        className="mt-3 mb-0"
                                        controlId="specialInstructions"
                                    >
                                        <Form.Label className="mb-1">Special Instructions</Form.Label>
                                        <Form.Control as="textarea" rows="2" name="specialInstructions" size="sm" aria-label="SpecialInstructions" value={props.newItemCriteria.specialInstructions} style={{ resize: 'none', whiteSpace: 'pre-line' }} maxLength="250" onChange={props.handleInputChange} />
                                        <p style={{ marginTop: '5px', marginBottom: 0, fontSize: '.8rem', color: '#94a3b8' }}>
                                            Max 250 Characters
                                        </p>
                                    </Form.Group>
                                }
                            })()}
                        </Form>
                    </div>

                    {/* Section 2 — upload files */}
                    <div style={{ ...sectionCard, flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, marginBottom: 0 }}>
                        <div style={sectionHeader}>
                            <span style={stepBadge}>2</span>Upload Files
                            <span style={{ fontWeight: 400, fontSize: '0.78rem', color: '#94a3b8', marginLeft: 'auto' }}>
                                {(props.docConversionNetworkType === 2 ? "PDF" : "PDF, TIF, TIFF, XLSX, XLS")}
                            </span>
                        </div>
                        <div
                            style={dropZone(props.dragging)}
                            onClick={() => fileInputRef.current && fileInputRef.current.click()}
                            onDrop={props.handleDrop}
                            onDragOver={(event) => event.preventDefault()}
                            onDragEnter={props.handleDragEnter}
                            onDragLeave={props.handleDragLeave}
                        >
                            <input
                                ref={fileInputRef}
                                type="file"
                                multiple
                                style={{ display: 'none' }}
                                onChange={props.handlefileInputChange}
                                accept={(props.docConversionNetworkType === 2 ? ".pdf" : ".pdf, .tif, .tiff, .xlsx, .xls")}
                            />
                            {props.uploadFiles.length === 0 ? (
                                <div>
                                    <FontAwesomeIcon icon={faCloudArrowUp} style={{ fontSize: '42px', color: ACCENT, marginBottom: '14px' }} />
                                    <div style={{ fontSize: '1rem', fontWeight: 600, color: '#334155' }}>Drag &amp; drop files here</div>
                                    <div style={{ fontSize: '0.85rem', color: '#94a3b8', marginTop: '4px' }}>
                                        or <span style={{ color: ACCENT, fontWeight: 600 }}>browse</span> to choose files
                                    </div>
                                </div>
                            ) : (
                                <ul
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ listStyleType: 'none', flex: 1, minHeight: 0, width: '100%', overflow: 'auto', margin: 0, padding: '4px' }}
                                >
                                    {props.uploadFiles.map((file, index) => {
                                        const fi = fileIcon(file.name);
                                        return (
                                            <li key={index} style={fileChip}>
                                                <FontAwesomeIcon icon={fi.icon} style={{ fontSize: '22px', color: fi.color, flexShrink: 0 }} />
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div style={{ fontWeight: 600, color: '#0f172a', fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{file.name}</div>
                                                    <div style={{ fontSize: '0.72rem', color: '#94a3b8' }}>
                                                        {(file.size / 1024).toFixed(1)} KB · {file.lastModifiedDate.toLocaleDateString()}
                                                    </div>
                                                </div>
                                                <FontAwesomeIcon
                                                    icon={faXmark}
                                                    style={{ cursor: 'pointer', color: '#94a3b8', padding: '6px', flexShrink: 0 }}
                                                    onClick={(e) => { e.stopPropagation(); props.handleRemoveFile(index); }}
                                                />
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                    </div>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'left'
                            }}
                        >
                            <Button
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '1px solid #cbd5e1',
                                    color: '#475569',
                                    fontWeight: 600
                                }}
                                onClick={props.onHide}
                                onMouseEnter={e => { e.target.style.backgroundColor = '#f1f5f9'; }}
                                onMouseLeave={e => { e.target.style.backgroundColor = 'transparent'; }}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'right'
                            }}
                        >
                            <Button
                                style={{...btnGold}}
                                onClick={props.handleBlobUpload}
                                disabled={props.uploadFiles.length === 0 || props.newItemCriteria.deliveryEmail.length < 1 || !props.isEmailValid}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                Upload Files
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

function DocumentUploadModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>STEP 2: Upload Document</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container style={{ height: '450px' }} >
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '-10px'
                            }}>
                            <h5>
                                Supported file types to convert:
                                {(props.docConversionNetworkType === 2 ? " PDF" : " PDF, TIF, TIFF, XLSX, XLS")}
                            </h5>
                        </Col>
                    </Row>
                    <Form>                        
                        <Form.Group className="mb-3" controlId="buttonSelectFile">
                            <Form.Label><br /></Form.Label>
                            <Form.Control
                                type="file"
                                size="sm"
                                multiple
                                onChange={props.handlefileInputChange}
                                accept={(props.docConversionNetworkType === 2 ? ".pdf" : ".pdf, .tif, .tiff, .xlsx, .xls")}
                            />
                        </Form.Group>
                    </Form>
                    <Row>
                        <Col>
                            <div
                                style={{
                                    border: (props.dragging ? '4px dashed lightgray' : '2px dashed lightgray'),
                                    borderRadius: '10px',
                                    backgroundColor: (props.dragging ? 'honeydew' : 'white'),
                                    height: '300px',
                                    color: 'gray',
                                    textAlign: 'center',
                                    verticalAlign: 'middle'
                                }}
                                onDrop={props.handleDrop}
                                onDragOver={(event) => event.preventDefault()}
                                onDragEnter={props.handleDragEnter}
                                onDragLeave={props.handleDragLeave}
                            >
                                <p
                                    style={{
                                        fontSize: '24px'
                                    }}
                                >
                                    Drag and drop your files here...
                                </p>
                                <ul
                                    style={{
                                        listStyleType: "none",
                                        height: "240px",
                                        overflow: "auto",
                                        marginLeft: '-20px',
                                        marginRight: '20px',
                                        paddingRight: '10px'
                                    }}
                                >
                                    {props.uploadFiles.map((file, index) => (
                                        <li
                                            key={index}
                                            style={{
                                                marginBottom: "10px"
                                            }}
                                        >
                                            <Card className="mb-4">
                                                <Card.Header
                                                    style={{
                                                        backgroundColor: 'lightgray',
                                                        height: '40px'
                                                    }}
                                                >                                                    
                                                    <Row>
                                                        <Col xs={11} >
                                                            <p
                                                                style={{
                                                                    fontWeight: '700'
                                                                }}
                                                            >
                                                                {file.name}
                                                            </p>
                                                        </Col>
                                                        <Col xs={1}>
                                                            <FontAwesomeIcon
                                                                icon={faXmark}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    padding: '5px',
                                                                    width: '20px',
                                                                    height: '20px'
                                                                }}
                                                                onClick={() => props.handleRemoveFile(index)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card.Header>
                                                <Card.Body
                                                    style={{
                                                        height: '50px'
                                                    }}
                                                >
                                                     Size: {file.size} bytes - LastModified: {file.lastModifiedDate.toLocaleDateString()}
                                                </Card.Body>
                                            </Card>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'left'
                            }}
                        >
                            <Button
                                style={{...btnGold}}
                                onClick={props.onHide}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                &lt;&lt; Back
                            </Button>
                        </Col>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'right'
                            }}
                        >
                            <Button
                                style={{...btnGold}}
                                onClick={props.handleBlobUpload}
                                disabled={props.disableUploadButton || props.uploadFiles.length === 0}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                Upload Files
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

function CategoryAddModal(props) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Add Organization</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container
                    style={{
                        height: '125px'
                    }}
                >
                    <Form>
                        <Form.Group as={Row} className="mb-3" controlId="categoryCode">
                            <Form.Label column sm={3}>Org Code</Form.Label>
                            <Col sm={5}>
                                <Form.Control
                                    name="categoryCode"
                                    size="sm"
                                    aria-label="Organization Code"
                                    style={{
                                        width: '100'
                                    }}
                                    value={props.newCategory.categoryCode}
                                    isInvalid={!props.isCategoryCodeValid}
                                    onChange={props.handleCategoryInputChange}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter an Org Code.
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="categoryName">
                            <Form.Label column sm={3}>
                                Org Name
                            </Form.Label>
                            <Col sm={6}>
                                <Form.Control
                                    name="categoryName"
                                    size="sm"
                                    aria-label="Organization Name"
                                    style={{
                                        width: '400'
                                    }}
                                    value={props.newCategory.categoryName}
                                    isInvalid={!props.isCategoryNameValid}
                                    onChange={props.handleCategoryInputChange} />
                                <Form.Control.Feedback type="invalid">
                                    Please enter an Org Name.
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                    </Form>                    
                    {(() => {
                        if (props.newCategory.exceptionMessage !== "") {
                            return <Row>
                                <Col
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        marginBottom: '-10px'
                                    }}>
                                    <p
                                        style={{
                                            color: 'red'
                                        }}
                                    >
                                        The entered Org Code already exists.  Codes must be unique.
                                    </p>
                                </Col>
                            </Row>
                        }
                    })()}
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'left'
                            }}>
                            <Button
                                style={{...btnGold}}
                                onClick={props.onHide}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'right'
                            }}
                        >
                            <Button
                                style={{...btnGold}}
                                onClick={props.handleAddCategory}
                                disabled={props.newCategory.categoryCode.length < 1 || props.newCategory.categoryName.length < 1}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                Save
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

function CategoryChangeConfirmationModal(props) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>
                        Confirm Org Change
                    </h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container
                    style={{
                        height: '125px'
                    }}
                >
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                marginBottom: '-10px'
                            }}
                        >
                            <p>
                                Do you wish to change the Org for ALL items for this Conversion (Id: {props.categoryChangeCriteria.statementId}), or only this item?
                            </p>
                        </Col>
                    </Row>
                    <Row
                        style={{
                            marginTop: '20px'
                        }}
                    >
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                        >
                            <Button
                                onClick={() =>
                                    props.saveItemCategoryChange(props.categoryChangeCriteria.statementId, props.categoryChangeCriteria.sequenceNumber, props.categoryChangeCriteria.statementCategoryId, false)}
                                style={{
                                    ...btnGold,
                                    width: '150px'
                                }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                Only this Item
                            </Button>
                            <Button
                                type='button'
                                size='sm'
                                style={{
                                    ...btnGold,
                                    marginLeft: '20px',
                                    width: '150px'
                                }}
                                onClick={() =>
                                    props.saveItemCategoryChange(props.categoryChangeCriteria.statementId, props.categoryChangeCriteria.sequenceNumber, props.categoryChangeCriteria.statementCategoryId, true)}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                All Items
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Container>
                    <Row>
                        <Col
                            style={{
                                display: 'flex',
                                justifyContent: 'left'
                            }}
                        >
                            <Button
                                style={{...btnGold}}
                                onClick={props.onHide}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                            >
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

// Popup shown when an admin clicks the "Mapping Needed" status pill on a
// row in the Document Conversion table. Renders two conditional sections:
//   1. Sender Code  — when props.data.needsOperatorMapping is true.
//      Pre-fills the operator name from the loaded PDF; admin enters the
//      2-digit CDEX sender code; Save inserts AccountOperatorCode + writes
//      Statement.AccountOperatorCodeId + flips DataFile.OwnersMapped.
//   2. CDEX Codes   — when props.data.needsCdexCodesMapping is true.
//      Lists every unmapped product code (and its unmapped transaction
//      child rows). Admin enters CDEX Product Code per product and CDEX
//      Transaction Code + REV Line Type per transaction. Save inserts
//      master rows under the global mapping account and writes the FKs
//      back onto the DataFileProductCode / DataFileTransactionCode rows.
//
// Sections are independent — saving one doesn't auto-save the other, but
// both can be filled in and saved one after the other (or just whichever
// is needed). After each save the parent refreshes the doc-conversion
// table so the status pill flips to Available when everything is mapped.
function MappingNeededModal(props) {
    const {
        show,
        onHide,
        statementIdString,
        loading,
        error,
        data,
        senderCodeInput,
        setSenderCodeInput,
        productMappings,
        setProductMappings,
        transactionMappings,
        setTransactionMappings,
        savingSenderCode,
        savingCdexCodes,
        onSaveSenderCode,
        onSaveCdexCodes,
        hasImpersonate,
        revLineTypeOptions
    } = props;

    //2-char limit + uppercase normalization for CDEX sender code.
    const handleSenderCodeChange = (e) => {
        let v = (e.target.value || '');
        if (v.length > 2) v = v.substring(0, 2);
        setSenderCodeInput(v.toUpperCase());
    };

    //Per-product CDEX Product Code edit. 2-char limit + uppercase.
    const handleProductCodeChange = (dataFileProductCodeId, value) => {
        let v = (value || '');
        if (v.length > 2) v = v.substring(0, 2);
        setProductMappings(prev => ({
            ...prev,
            [dataFileProductCodeId]: { ...(prev[dataFileProductCodeId] || {}), cdexProductCode: v.toUpperCase() }
        }));
    };

    //Per-transaction CDEX Transaction Code edit. 3-char limit + uppercase
    //(matches the convention in CdexCodes_dc page).
    const handleTransactionCodeChange = (dataFileTransactionCodeId, value) => {
        let v = (value || '');
        if (v.length > 3) v = v.substring(0, 3);
        setTransactionMappings(prev => ({
            ...prev,
            [dataFileTransactionCodeId]: { ...(prev[dataFileTransactionCodeId] || {}), cdexTransactionCode: v.toUpperCase() }
        }));
    };

    const handleTransactionRevLineTypeChange = (dataFileTransactionCodeId, value) => {
        setTransactionMappings(prev => ({
            ...prev,
            [dataFileTransactionCodeId]: { ...(prev[dataFileTransactionCodeId] || {}), revLineTypeCode: value }
        }));
    };

    //Sender code save is enabled only when the user has typed at least one char.
    const senderCodeReady = senderCodeInput && senderCodeInput.length > 0;

    //CDEX save is enabled when at least one editable field has a value AND every
    //transaction with a CDEX code also has a REV line type (since they're paired).
    const cdexReady = (() => {
        if (!data || !data.needsCdexCodesMapping) return false;
        const products = data.unmappedProducts || [];
        let anyEdited = false;
        for (const p of products) {
            const pm = productMappings[p.dataFileProductCodeId];
            if (pm && pm.cdexProductCode) anyEdited = true;
            for (const t of (p.unmappedTransactions || [])) {
                const tm = transactionMappings[t.dataFileTransactionCodeId];
                if (!tm) continue;
                const code = tm.cdexTransactionCode || '';
                const rev = tm.revLineTypeCode || '';
                if (code && !rev) return false;
                if (!code && rev) return false;
                if (code) anyEdited = true;
            }
        }
        return anyEdited;
    })();

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            backdrop="static"
            aria-labelledby="mapping-needed-modal-title"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="mapping-needed-modal-title">
                    <h4 style={{ marginBottom: 0 }}>
                        Mapping Needed
                        {statementIdString ? <span style={{ fontSize: '0.85rem', color: '#666', marginLeft: '10px' }}>&mdash; Statement {statementIdString}</span> : null}
                    </h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" role="status" size="sm" />
                        <span className="ms-2">Loading mapping data...</span>
                    </div>
                ) : error ? (
                    <Alert variant="danger" className="mb-0">{error}</Alert>
                ) : !data ? (
                    <p className="fst-italic text-muted mb-0">No mapping data loaded.</p>
                ) : (
                    <>
                        {/* SENDER CODE SECTION — conditional. Flex layout (not Bootstrap grid)
                            so the 2-digit input stays small, the operator name takes whatever
                            space is left, and Save sits right next to the input with all three
                            elements bottom-aligned. */}
                        {data.needsOperatorMapping ? (
                            <div style={{
                                marginBottom: '24px',
                                paddingBottom: '24px',
                                borderBottom: '2px solid #000',
                                position: 'relative'
                            }}>
                                <h6 style={{ fontSize: '1.1rem', fontWeight: 800, marginBottom: '12px', textAlign: 'center', letterSpacing: '.02em' }}>CDEX Sender Code</h6>
                                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '20px', flexWrap: 'wrap' }}>
                                    <div style={{ flex: '1 1 300px', minWidth: '200px' }}>
                                        <Form.Label style={{ fontSize: '.78rem', marginBottom: '2px', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '.04em' }}>Operator Name (Sender)</Form.Label>
                                        <div style={{ fontSize: '.9rem', fontWeight: 600 }}>{data.operatorName || '(none on file)'}</div>
                                    </div>
                                    <div style={{ flexShrink: 0, textAlign: 'center' }}>
                                        <Form.Label style={{ fontSize: '.78rem', marginBottom: '2px', color: '#6b7280', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '.04em', display: 'block', textAlign: 'center' }}>CDEX Sender Code</Form.Label>
                                        <Form.Control
                                            type="text"
                                            size="sm"
                                            maxLength={2}
                                            value={senderCodeInput}
                                            onChange={handleSenderCodeChange}
                                            placeholder=""
                                            style={{ fontSize: '.9rem', textTransform: 'uppercase', width: '70px', textAlign: 'center', fontWeight: 600, margin: '0 auto' }}
                                        />
                                    </div>
                                    <div style={{ flexShrink: 0 }}>
                                        <Button
                                            size="sm"
                                            style={{ ...btnGold, minWidth: '80px' }}
                                            disabled={!senderCodeReady || savingSenderCode}
                                            onClick={onSaveSenderCode}
                                        >
                                            {savingSenderCode ? 'Saving…' : 'Save'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {/* CDEX CODES SECTION — conditional. Each product is rendered as a
                            grouped block: a darker header row with the product name + CDEX
                            input on top, then any unmapped transactions indented underneath
                            with a gold left-border tying them visually to their parent.
                            Account/CDEX-code mapping is admin-only — gate on
                            hasImpersonate so a non-admin CDEX client (who only
                            reaches this popup to map the sender code) can never
                            render the accounts section, even if state changes. */}
                        {hasImpersonate && data.needsCdexCodesMapping ? (
                            <div>
                                {/* 3-column flex: product count anchored left, title dead-center,
                                    Map button anchored right. Count gives the admin a quick "how
                                    much do I have to do" read without crowding the title. */}
                                {(() => {
                                    const productCount = (data.unmappedProducts || []).length;
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                                            <div style={{ flex: 1, textAlign: 'left', fontSize: '.85rem', color: '#6b7280', fontWeight: 500 }}>
                                                {productCount} {productCount === 1 ? 'product' : 'products'}
                                            </div>
                                            <h6 style={{ fontSize: '1.1rem', fontWeight: 800, margin: 0, textAlign: 'center', letterSpacing: '.02em' }}>CDEX Codes</h6>
                                            <div style={{ flex: 1, textAlign: 'right' }}>
                                                <Button
                                                    size="sm"
                                                    style={{ ...btnGold, minWidth: '160px' }}
                                                    disabled={!cdexReady || savingCdexCodes}
                                                    onClick={onSaveCdexCodes}
                                                >
                                                    {savingCdexCodes ? 'Saving…' : 'Map CDEX Codes'}
                                                </Button>
                                            </div>
                                        </div>
                                    );
                                })()}

                                {(!data.unmappedProducts || data.unmappedProducts.length === 0) ? (
                                    <p className="fst-italic text-muted mb-0">No unmapped product or transaction codes for this statement.</p>
                                ) : (
                                    /* Bordered scroll container — gets its own max height + scroll
                                       so the rows scroll independently. The dark column-header bar
                                       below is position: sticky so it pins to the top of THIS
                                       container as the rows scroll under it. */
                                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 4, overflowY: 'auto', maxHeight: '45vh' }}>
                                        {/* Column headers. Column widths match the rows below
                                            so values line up under their headers. Total = 12.
                                            Sticky inside the scroll container. */}
                                        <div style={{ background: '#333', color: '#f1f1f1', padding: '6px 10px', fontSize: '.78rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '.04em', position: 'sticky', top: 0, zIndex: 2 }}>
                                            <Row className="g-0">
                                                <Col xs={2}>Product Desc</Col>
                                                <Col xs={2} style={{ whiteSpace: 'nowrap' }}>CDEX Product Code</Col>
                                                <Col xs={4} style={{ textAlign: 'right', paddingRight: '12px' }}>Interest Type Desc</Col>
                                                <Col xs={2}>CDEX Trx Code</Col>
                                                <Col xs={2}>REV Line</Col>
                                            </Row>
                                        </div>

                                        {data.unmappedProducts.map((prod, prodIdx) => {
                                            const pm = productMappings[prod.dataFileProductCodeId] || {};
                                            const txList = prod.unmappedTransactions || [];
                                            return (
                                                <div
                                                    key={prod.dataFileProductCodeId}
                                                    style={{
                                                        paddingTop: '12px',
                                                        paddingBottom: '12px',
                                                        borderTop: prodIdx === 0 ? 'none' : '1px solid #d1d5db'
                                                    }}
                                                >
                                                    {/* Product header row — darker bg so the product reads as a group title.
                                                        If the product is already mapped (isProductMapped) we show its
                                                        existing CDEX code as read-only so the admin can see what it is
                                                        while finishing the unmapped transaction children below. */}
                                                    <Row className="g-0 align-items-center" style={{ padding: '8px 10px', background: '#eef0f3', margin: 0 }}>
                                                        <Col xs={2} style={{ fontWeight: 700, fontSize: '.9rem', color: '#1f2937' }}>{prod.productDesc}</Col>
                                                        <Col xs={2}>
                                                            {prod.isProductMapped ? (
                                                                <div style={{
                                                                    fontSize: '.85rem',
                                                                    fontWeight: 700,
                                                                    color: '#1f2937',
                                                                    textAlign: 'center',
                                                                    width: '64px',
                                                                    padding: '2px 6px',
                                                                    backgroundColor: '#e5e7eb',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '4px',
                                                                }} title="Already mapped">
                                                                    {prod.cdexProductCode || ''}
                                                                </div>
                                                            ) : (
                                                                <Form.Control
                                                                    type="text"
                                                                    size="sm"
                                                                    maxLength={2}
                                                                    value={pm.cdexProductCode || ''}
                                                                    onChange={(e) => handleProductCodeChange(prod.dataFileProductCodeId, e.target.value)}
                                                                    style={{ fontSize: '.85rem', textTransform: 'uppercase', height: '26px', lineHeight: 1.2, padding: '0px 6px', width: '64px', textAlign: 'center', fontWeight: 600 }}
                                                                />
                                                            )}
                                                        </Col>
                                                        <Col xs={8} style={{ fontSize: '.78rem', color: '#9ca3af', fontStyle: 'italic' }}>
                                                            {txList.length === 0 ? '(no unmapped transactions under this product)' : ''}
                                                        </Col>
                                                    </Row>

                                                    {/* Transaction rows — indented + gold left-border to show they belong
                                                        to the product above. Columns align with the header above. */}
                                                    {txList.map((tx, txIdx) => {
                                                        const tm = transactionMappings[tx.dataFileTransactionCodeId] || {};
                                                        return (
                                                            <Row
                                                                key={tx.dataFileTransactionCodeId}
                                                                className="g-0 align-items-center"
                                                                style={{
                                                                    padding: '4px 10px 4px 24px',
                                                                    margin: 0,
                                                                    background: txIdx % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                                    borderTop: txIdx === 0 ? '1px solid #e5e7eb' : '1px solid #f3f4f6',
                                                                    position: 'relative'
                                                                }}
                                                            >
                                                                {/* Visual "this belongs to the product above" indicator —
                                                                    a gold vertical tick on the left edge of each transaction row. */}
                                                                <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '3px', background: '#c8b668' }} />
                                                                <Col xs={2}></Col>
                                                                <Col xs={2}></Col>
                                                                <Col xs={4} style={{ fontSize: '.85rem', color: '#374151', textAlign: 'right', paddingRight: '12px' }}>{tx.transactionDesc}</Col>
                                                                <Col xs={2}>
                                                                    <Form.Control
                                                                        type="text"
                                                                        size="sm"
                                                                        maxLength={3}
                                                                        value={tm.cdexTransactionCode || ''}
                                                                        onChange={(e) => handleTransactionCodeChange(tx.dataFileTransactionCodeId, e.target.value)}
                                                                        style={{ fontSize: '.85rem', textTransform: 'uppercase', height: '26px', lineHeight: 1.2, padding: '0px 6px', width: '70px', textAlign: 'center', fontWeight: 600 }}
                                                                    />
                                                                </Col>
                                                                <Col xs={2}>
                                                                    <Form.Select
                                                                        size="sm"
                                                                        value={tm.revLineTypeCode || ''}
                                                                        onChange={(e) => handleTransactionRevLineTypeChange(tx.dataFileTransactionCodeId, e.target.value)}
                                                                        style={{ fontSize: '.8rem', height: '26px', padding: '0px 22px 0px 6px', lineHeight: 1.2, backgroundPosition: 'right 4px center', width: '70px' }}
                                                                    >
                                                                        {revLineTypeOptions.map((opt, i) => (
                                                                            <option key={i} value={opt.code}>{opt.value}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </Col>
                                                            </Row>
                                                        );
                                                    })}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        ) : null}

                        {!data.needsOperatorMapping && !data.needsCdexCodesMapping ? (
                            <p className="fst-italic text-muted mb-0">No mappings are needed for this statement.</p>
                        ) : null}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={onHide}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

// Delete/re-run only for statements uploaded after this date (mirrored in the API checks)
const EXCEPTION_ACTION_CUTOFF_DATE = new Date(2026, 6, 6); // July 6, 2026

// Dialog opened from the Exception status pill (admins, non-IMTS rows only).
// Re-run re-queues the conversion; Delete soft-deletes the statement. Stays
// open after an action so result/warning messages are visible.
function ExceptionActionModal(props) {
    const {
        show,
        onHide,
        statementIdString,
        busyAction,          // 'delete' | 'rerun' | null
        completedAction,     // 'delete' | 'rerun' | null
        error,
        warning,
        successMessage,
        confirmingDelete,
        setConfirmingDelete,
        onDelete,
        onRerun
    } = props;

    const busy = busyAction !== null;
    const done = completedAction !== null;

    return (
        <Modal
            show={show}
            onHide={busy ? () => {} : onHide}
            size="md"
            backdrop="static"
            aria-labelledby="exception-action-modal-title"
            centered
        >
            {/* closing is blocked while an action is in flight */}
            <Modal.Header closeButton={!busy}>
                <Modal.Title id="exception-action-modal-title">
                    <h4 style={{ marginBottom: 0 }}>
                        Exception
                        {statementIdString ? <span style={{ fontSize: '0.85rem', color: '#666', marginLeft: '10px' }}>&mdash; Statement {statementIdString}</span> : null}
                    </h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!done ? (
                    <p style={{ fontSize: '.9rem', color: '#475569' }}>
                        This statement failed to convert. You can re-run the conversion or delete the statement.
                    </p>
                ) : null}

                {error ? <Alert variant="danger" className="mb-2">{error}</Alert> : null}
                {successMessage ? <Alert variant="success" className="mb-2">{successMessage}</Alert> : null}
                {warning ? <Alert variant="warning" className="mb-2">{warning}</Alert> : null}

                {!done ? (
                    confirmingDelete ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginTop: '8px' }}>
                            <span style={{ fontSize: '.9rem', fontWeight: 600 }}>Delete this statement?</span>
                            <Button
                                size="sm"
                                variant="danger"
                                style={{ minWidth: '110px' }}
                                disabled={busy}
                                onClick={onDelete}
                            >
                                {busyAction === 'delete' ? 'Deleting…' : 'Yes, Delete'}
                            </Button>
                            <Button
                                size="sm"
                                variant="outline-secondary"
                                disabled={busy}
                                onClick={() => setConfirmingDelete(false)}
                            >
                                Cancel
                            </Button>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '8px' }}>
                            <Button
                                size="sm"
                                style={{ ...btnGold, minWidth: '150px' }}
                                disabled={busy}
                                onClick={onRerun}
                            >
                                {busyAction === 'rerun' ? 'Re-running…' : 'Re-run Conversion'}
                            </Button>
                            <Button
                                size="sm"
                                variant="outline-danger"
                                style={{ minWidth: '150px' }}
                                disabled={busy}
                                onClick={() => setConfirmingDelete(true)}
                            >
                                Delete Statement
                            </Button>
                        </div>
                    )
                ) : null}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    size="sm"
                    disabled={busy}
                    onClick={onHide}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

const nameDropdownStyles = {
    menu: {
        padding: 0,
        minWidth: 300,
        maxWidth: '90vw',
        overflow: 'hidden',
        border: '1px solid #d9d9d9',
        borderRadius: 6,
        boxShadow: '0 8px 24px rgba(0, 0, 0, .15)',
        '--bs-dropdown-link-active-bg': COLORS.gold,
        '--bs-dropdown-link-active-color': '#1a1a1a'
    },
    header: {
        padding: 8,
        backgroundColor: '#fafafa',
        borderBottom: '1px solid #e5e5e5'
    },
    searchWrap: {
        position: 'relative'
    },
    searchIcon: {
        position: 'absolute',
        left: 9,
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#9ca3af',
        fontSize: '0.7rem',
        pointerEvents: 'none'
    },
    input: {
        fontSize: '0.75rem',
        height: 28,
        padding: '4px 26px 4px 26px',
        border: '1px solid #ced4da',
        borderRadius: 4,
        boxShadow: 'none'
    },
    inputFocus: {
        borderColor: COLORS.gold,
        boxShadow: '0 0 0 0.15rem rgba(200, 182, 104, .45)'
    },
    inputBlur: {
        borderColor: '#ced4da',
        boxShadow: 'none'
    },
    clearBtn: {
        position: 'absolute',
        right: 4,
        top: '50%',
        transform: 'translateY(-50%)',
        border: 'none',
        background: 'transparent',
        color: '#9ca3af',
        fontSize: '0.75rem',
        padding: '2px 6px',
        lineHeight: 1,
        cursor: 'pointer'
    },
    allItem: {
        marginTop: 6,
        padding: '5px 10px',
        fontSize: '0.75rem',
        fontWeight: 700,
        borderRadius: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    list: {
        maxHeight: 260,
        overflowY: 'auto',
        padding: '4px 0'
    },
    item: {
        fontSize: '0.75rem',
        padding: '5px 12px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    selected: {
        backgroundColor: 'rgba(200, 182, 104, .2)',
        fontWeight: 600
    },
    footer: {
        padding: '4px 12px',
        fontSize: '0.68rem',
        color: '#6b7280',
        borderTop: '1px solid #e5e5e5',
        backgroundColor: '#fafafa'
    },
    empty: {
        padding: '12px',
        fontSize: '0.75rem',
        color: '#6b7280',
        textAlign: 'center'
    }
};

const receivedRangeStyles = {
    group: {
        display: 'flex',
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
        height: 22,
        padding: '0 3px 0 6px',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#ced4da',
        borderRadius: 4,
        backgroundColor: '#fff',
        boxSizing: 'border-box'
    },
    groupFocus: {
        borderColor: COLORS.gold,
        boxShadow: '0 0 0 0.15rem rgba(200, 182, 104, .45)'
    },
    groupInvalid: {
        borderColor: COLORS.red
    },
    groupDisabled: {
        backgroundColor: '#e9ecef',
        opacity: 0.75
    },
    tag: {
        fontSize: '0.6rem',
        fontWeight: 700,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        color: '#6b7280',
        whiteSpace: 'nowrap'
    },
    select: {
        fontSize: '0.65rem',
        fontWeight: 600,
        color: '#111827',
        height: 16,
        minHeight: 16,
        lineHeight: 1,
        width: 'auto',
        padding: '0 18px 0 6px',
        backgroundPosition: 'right 4px center',
        backgroundColor: '#eef0f3',
        border: '1px solid #d1d5db',
        borderRadius: 3,
        boxShadow: 'none',
        cursor: 'pointer'
    },
    divider: {
        width: 1,
        alignSelf: 'stretch',
        margin: '3px 6px',
        backgroundColor: '#d1d5db'
    }
};

const isReceivedRangeInverted = (criteria) =>
    Number(criteria.fromYear) * 12 + Number(criteria.fromMonth) > Number(criteria.toYear) * 12 + Number(criteria.toMonth);

//searchable name picker: search box and "All" stay pinned, names scroll beneath
function NameFilterDropdown({ id, label, term, names, totalCount, selectedName, disabled, toggleStyle, onTermChange, onSelect }) {
    const inputRef = React.useRef(null);
    const visibleNames = names.filter(n => typeof n === 'string' && n.trim().length > 0);

    const handleToggle = (show) => {
        if (show) {
            setTimeout(() => inputRef.current && inputRef.current.focus(), 0);
        }
    };

    return (
        <Dropdown onToggle={handleToggle}>
            <Dropdown.Toggle
                id={id}
                bsPrefix="form-select"
                variant="light"
                disabled={disabled}
                size="sm"
                style={{ ...toggleStyle, display: 'block' }}
                title={term || ''}
                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
            >
                {term || "Search..."}
            </Dropdown.Toggle>

            <Dropdown.Menu style={nameDropdownStyles.menu}>
                <div style={nameDropdownStyles.header}>
                    <div style={nameDropdownStyles.searchWrap}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} style={nameDropdownStyles.searchIcon} />
                        <FormControl
                            ref={inputRef}
                            placeholder={'Search ' + label.toLowerCase() + 's...'}
                            aria-label={'Search ' + label.toLowerCase()}
                            disabled={disabled}
                            value={term}
                            onChange={e => { e.preventDefault(); onTermChange(e.target.value); }}
                            style={nameDropdownStyles.input}
                            onFocus={e => Object.assign(e.target.style, nameDropdownStyles.inputFocus)}
                            onBlur={e => Object.assign(e.target.style, nameDropdownStyles.inputBlur)}
                        />
                        {term ? (
                            <button
                                type="button"
                                aria-label="Clear search"
                                style={nameDropdownStyles.clearBtn}
                                onClick={() => { onTermChange(''); inputRef.current && inputRef.current.focus(); }}
                            >
                                <FontAwesomeIcon icon={faXmark} />
                            </button>
                        ) : null}
                    </div>
                    <Dropdown.Item
                        onClick={() => onSelect('')}
                        style={{ ...nameDropdownStyles.allItem, ...(selectedName === '' ? nameDropdownStyles.selected : {}) }}
                    >
                        <span>All {label}s</span>
                        {selectedName === '' ? <FontAwesomeIcon icon={faCheck} style={{ color: COLORS.goldDark }} /> : null}
                    </Dropdown.Item>
                </div>

                <div style={nameDropdownStyles.list}>
                    {visibleNames.length ? (
                        visibleNames.map((name) => (
                            <Dropdown.Item
                                key={name}
                                title={name}
                                onClick={() => onSelect(name)}
                                style={{ ...nameDropdownStyles.item, ...(name === selectedName ? nameDropdownStyles.selected : {}) }}
                            >
                                {name}
                            </Dropdown.Item>
                        ))
                    ) : (
                        <div style={nameDropdownStyles.empty}>No matching {label.toLowerCase()}s</div>
                    )}
                </div>

                <div style={nameDropdownStyles.footer}>
                    {visibleNames.length === totalCount
                        ? totalCount + ' ' + label.toLowerCase() + (totalCount === 1 ? '' : 's')
                        : visibleNames.length + ' of ' + totalCount + ' ' + label.toLowerCase() + 's'}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

const DocumentConversion = props => {
    const [showAdvanced, setShowAdvanced] = useState(false);

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently, user } = useAuth0();

    //stateful properties (hooks)
    const navigate = useNavigate();
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const [pageStatus, setPageStatus] = useState('loading');
    const [dataStatus, setDataStatus] = useState('');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');
    const [owners, setOwners] = useState([]);
    const [operators, setOperators] = useState([]);
    const [statementCategories, setStatementCategories] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState([]);
    const [checkStatements, setCheckStatements] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);
    const [statusItems, setStatusItems] = useState([{ id: 0, status: 'All' }, { id: 1, status: 'Processing' }, { id: 2, status: 'Available' }, { id: 3, status: 'Downloaded' }, { id: 4, status: 'Exception' }, { id: 5, status: 'Rejected' }, { id: 7, status: 'Mapping Needed' }, { id: 8, status: 'Duplicate' }]);
    const [statementTypes, setStatementTypes] = useState([{ id: 0, type: 'All' }, { id: 1, type: 'Revenue' }, { id: 2, type: 'JIB' }, { id: 3, type: 'Plant' }]);
    const [deliveryTimes, setDeliveryTimes] = useState([{ id: 0, time: 'All' }, { id: 1, time: 'Standard (3 days)' }, { id: 2, time: 'Rush (1 day)' }]);
    const [dataCriteria, setDataCriteria] = useState({
        skipCount: 0,
        takeCount: 50,
        statementIdString: '',
        statementTypeId: 0,
        statementCategoryId: 0,
        operatorName: '',
        operatorNameExact: false,
        ownerNumber: '',
        ownerName: '',
        ownerNameExact: false,
        checkNumber: '',
        checkAmount: '',
        statusId: 0,
        fromMonth: 0,
        fromYear: 0,
        toMonth: 0,
        toYear: 0,
        ownerId: '',
        checkDate: ''
    });

    const [newItemCriteria, setNewItemCriteria] = useState({
        statementTypeId: 1,
        deliveryTimeId: 1,
        statementCategoryId: 0,
        deliveryEmail: '',
        specialInstructions: '',
        selectedFile: null,
        uploadFiles: []
    });
    const [uploadFiles, setUploadFiles] = useState([]);
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [dragging, setDragging] = useState(false);

    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [screenHeight, setScreenHeight] = useState(100);

    const [documentInputModalShow, setDocumentInputModalShow] = useState(false);
    const [noDocConversionModalShow, setNoDocConversionModalShow] = useState(false);
    const [documentUploadModalShow, setDocumentUploadModalShow] = useState(false);
    const [categoryAddModalShow, setCategoryAddModalShow] = useState(false);
    const [categoryChangeConfirmationModalShow, setCategoryChangeConfirmationModalShow] = useState(false);

    // Mapping Needed popup. Opens from the status pill on rows whose statusId
    // is 7. Holds the fetched MappingNeedsDTO plus the user's in-progress edits
    // to the Sender Code / CDEX Codes form fields until Save is clicked.
    const [mappingNeededModalShow, setMappingNeededModalShow] = useState(false);
    const [mappingNeededStatementId, setMappingNeededStatementId] = useState(null);
    const [mappingNeededStatementIdString, setMappingNeededStatementIdString] = useState('');
    const [mappingNeededLoading, setMappingNeededLoading] = useState(false);
    const [mappingNeededError, setMappingNeededError] = useState('');
    const [mappingNeededData, setMappingNeededData] = useState(null);
    //Editable form values. senderCode is a single string (the 2-digit code).
    //productMappings is { [dataFileProductCodeId]: { cdexProductCode: '' } }.
    //transactionMappings is { [dataFileTransactionCodeId]: { cdexTransactionCode: '', revLineTypeCode: '' } }.
    const [senderCodeInput, setSenderCodeInput] = useState('');
    const [productMappings, setProductMappings] = useState({});
    const [transactionMappings, setTransactionMappings] = useState({});
    const [savingSenderCode, setSavingSenderCode] = useState(false);
    const [savingCdexCodes, setSavingCdexCodes] = useState(false);

    // Exception delete/re-run popup state
    const [exceptionActionModalShow, setExceptionActionModalShow] = useState(false);
    const [exceptionActionStatementId, setExceptionActionStatementId] = useState(null);
    const [exceptionActionStatementIdString, setExceptionActionStatementIdString] = useState('');
    const [exceptionActionBusy, setExceptionActionBusy] = useState(null);            // 'delete' | 'rerun' | null
    const [exceptionActionCompleted, setExceptionActionCompleted] = useState(null);  // 'delete' | 'rerun' | null
    const [exceptionActionError, setExceptionActionError] = useState('');
    const [exceptionActionWarning, setExceptionActionWarning] = useState('');
    const [exceptionActionSuccess, setExceptionActionSuccess] = useState('');
    const [exceptionConfirmingDelete, setExceptionConfirmingDelete] = useState(false);

    const [alertShow, setAlertShow] = useState(false);
    const [alertVariant, setAlertVariant] = useState('success');
    const [alertMessage, setAlertMessage] = useState('Success!');
    const [progressStatus, setProgressStatus] = useState(0);

    const [sortBy, setSortBy] = useState("StatusDate");
    const [sortDirection, setSortDirection] = useState("Descending");

    const [categoryEditItem, setCategoryEditItem] = useState(null);
    const [newCategory, setNewCategory] = useState({
        id: 0,
        categoryCode: '',
        categoryName: '',
        exceptionMessage : ''
    });
    const [isCategoryCodeValid, setIsCategoryCodeValid] = useState(true);
    const [isCategoryNameValid, setIsCategoryNameValid] = useState(true);

    const [categoryChangeCriteria, setCategoryChangeCriteria] = useState({
        statementId: 0,
        sequenceNumber: 0,
        statementCategoryId: 0,
        updateAllItems: false
    });

    const [docConversionNetworkType, setDocConversionNetworkType] = useState(0);
    const [docConversionOutputType, setDocConversionOutputType] = useState(0);

    //Conditional button text: Now hard coded "Data"
    //const [xlsButtonLabel, setXLSButtonLabel] = useState("XLS")

    const [isDev, setIsDev] = useState(true);

    const [screenHeightAdjust, setScreenHeightAdjust] = useState(302);

    /*****drop edit*****/
    //operator search
    const [filteredOperators, setFilteredOperators] = useState([]);
    const [unFilteredOperators, setUnfilteredOperators] = useState([]);
    const [searchOpTerm, setSearchOpTerm] = useState("");
    const filterNamesRangeRef = React.useRef('');

    /*****drop edit*****/
    //owner search
    const [filteredOwners, setFilteredOwners] = useState([]);
    const [unFilteredOwners, setUnfilteredOwners] = useState([]);
    const [searchOwnerTerm, setSearchOwnerTerm] = useState("");
    //category search
    const [filteredCategories, setFilteredCategories] = useState(statementCategories);
    const [searchCatTerm, setSearchCatTerm] = useState("");

    const [hoveredBtn, setHoveredBtn] = useState(null);

    // Map<key, docSnapshot> — snapshot of the doc fields we need to download it,
    // captured at selection time. Survives pagination since we don't rely on the
    // current page's `documents` array at batch time.
    const [selectedDownloads, setSelectedDownloads] = useState(new Map());
    const [batchDownloadSeq, setBatchDownloadSeq] = useState(1);
    const [groupDownloadFormat, setGroupDownloadFormat] = useState('excel'); // 'excel' | 'cdex'
    const selectionKey = (statementId, sequenceNumber) => `${statementId}|${sequenceNumber}`;
    const isSelected = (statementId, sequenceNumber) => selectedDownloads.has(selectionKey(statementId, sequenceNumber));
    const toggleSelection = (doc) => {
        setSelectedDownloads(prev => {
            const next = new Map(prev);
            const key = selectionKey(doc.statementId, doc.sequenceNumber);
            if (next.has(key)) {
                next.delete(key);
            } else {
                next.set(key, {
                    statementId: doc.statementId,
                    sequenceNumber: doc.sequenceNumber,
                    dataFileId: doc.dataFileId,
                    statementTypeId: doc.statementTypeId,
                    inputFileName: doc.inputFileName,
                });
            }
            return next;
        });
    };

    //initialize page
    useEffect(() => {
        (async () => {
            //console.log('Initializing page...');

            if (setIsShowSidebarMd)
                setIsShowSidebarMd(true);

            //get inner browser window height
            const height = window.innerHeight;
            setScreenHeight(height);

            await initializeForm()
                .then(response => {
                    setDocConversionNetworkType(response.docConversionNetworkType);
                    setDocConversionOutputType(response.docConversionOutputType);
                    setOperators(response.operators);
                    setOwners(response.owners);
                    setYears(response.dates.years);
                    setMonths(response.dates.months);
                    setStatementCategories(response.statementCategories);

                    setDataCriteria({
                        ...dataCriteria,
                        operatorId: response.operators[0].id,
                        //ownerId: response.owners[0] === null ? 0 : response.owners[0].id,
                        fromMonth: response.dates.fromMonth,
                        fromYear: response.dates.fromYear,
                        toMonth: response.dates.currMonth,
                        toYear: response.dates.currYear
                    });

                    setDocuments(response.documents.data);
                    setRowCount(response.documents.rowCount);

                    //default user's email address
                    setNewItemCriteria({
                        statementTypeId: 1,
                        deliveryTimeId: 1,
                        statementCategoryId: 0,
                        deliveryEmail: '',   //user.email
                        specialInstructions: '',
                        selectedFile: null,
                        uploadFiles: []
                    });
                    setUploadFiles([]);
                    setIsEmailValid(true);

                    setFilteredCategories(response.statementCategories);
                    applyFilterNames(response.filterNames || {
                        operatorNames: [...new Set(response.documents.data.map((doc) => doc.operatorName))].filter(n => typeof n === 'string'),
                        ownerNames: [...new Set(response.documents.data.map((doc) => doc.ownerName))].filter(n => typeof n === 'string')
                    }, '', '');

                    //Conditional button text: Now hard coded "Data"
                    //if (response.docConversionNetworkType === 2 && response.docConversionOutputType === 2) {
                    //    setXLSButtonLabel("CDEX");
                    //}

                    setDataStatus('ready');
                    setPageStatus('ready');
                })
                .catch(ex => {
                    setPageStatus('error');
                    setPageErrors(ex.message);
                })
                .finally(response => {
                    //do something
                })

        })();
    }, []);

    // WINDOW RESIZE HANDLER
    useEffect(() => {
        const handleResize = () => setScreenHeight(window.innerHeight);

        handleResize();                       // set initial height
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    //initialize form
    const initializeForm = async () => {
        //TODO: might just call populateOwners() from useEffect
        //console.log('Initializing form...');

        const docConversionNetworkType = await getDocConversionNetworkType();
        console.log("Doc Conversion Network Type: " + docConversionNetworkType.data);

        const docConversionOutputType = await getDocConversionOutputType();
        console.log("Doc Conversion Output Type: " + docConversionOutputType.data);

        //get dates for to/from dropdowns
        const dates = await getDates();

        //get operators for dropdown
        const operators = await getOperators();
        const newOperators = [{id: 0, companyName: ''}, ...operators.data];

        //get owners for dropdown
        const owners = await getOwners();

        //get statement categories for dropdown
        const statementCategories = await getStatementCategories();

        const currentCriteria = {
            ...dataCriteria,
            fromMonth: dates.fromMonth,
            fromYear: dates.fromYear,
            toMonth: dates.currMonth,
            toYear: dates.currYear,
            skipCount: 0
        };
        const documents = await getStatements(currentCriteria, sortBy, sortDirection);

        const filterNames = await getFilterNames(currentCriteria);

        //'&checkNumber=' + currentCriteria.checkNumber + '&checkDate=' + currentCriteria.checkDate + '&ownerIdString=' + currentCriteria.ownerId + '&statusId=' + currentCriteria.statusId + '&skipCount=' + currentCriteria.skipCount + '&takeCount=' + currentCriteria.takeCount;

        return { success: true, docConversionNetworkType: docConversionNetworkType.data, docConversionOutputType: docConversionOutputType.data, operators: newOperators, owners: owners.data, statementCategories: statementCategories.data, dates: dates, documents: documents.data, filterNames: filterNames };

        //TODO: might want to clean this up with .then /.catch, but how to do with multiple api calls?
        //.then(get other data)
        //.catch(ex => throw...)
    };

    const getDates = () => {

        const date = new Date();
        //const day = date.getDate();
        const currMonth = date.getMonth() + 1;
        const currYear = date.getFullYear();

        const fromMonth = currMonth === 1 ? 12 : currMonth - 1;
        const fromYear = currMonth === 1 ? currYear - 1 : currYear;

        const years = [currYear - 3, currYear - 2, currYear - 1, currYear, currYear + 1];
        //const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        return { months: months, years: years, currMonth: currMonth, currYear: currYear, fromMonth: fromMonth, fromYear: fromYear };
    };

    //get conversion statements
    const getStatements = async (currentCriteria, sortBy, sortDirection) => {
        //console.log('Getting Statements...');

        console.log('StatementId: ' + dataCriteria.statementId);

        let apiUrl = '';
        if (accountProfile.hasDocConversion) {
            //apiUrl = 'accounts/allconversionstatements?statementIdString=' + currentCriteria.statementIdString + '&statementTypeId=' + currentCriteria.statementTypeId + '&statementCategoryId=' + currentCriteria.statementCategoryId + '&fromMonth=' + currentCriteria.fromMonth + '&fromYear=' + currentCriteria.fromYear + '&toMonth=' + currentCriteria.toMonth + '&toYear=' + currentCriteria.toYear + '&operatorName=' + currentCriteria.operatorName + '&ownerNumber=' + currentCriteria.ownerNumber + '&ownerName=' + currentCriteria.ownerName + '&checkNumber=' + currentCriteria.checkNumber + '&checkDate=' + currentCriteria.checkDate + '&ownerIdString=' + currentCriteria.ownerId + '&statusId=' + currentCriteria.statusId + '&skipCount=' + currentCriteria.skipCount + '&takeCount=' + currentCriteria.takeCount + '&sortBy=' + sortBy + '&sortDirection=' + sortDirection;
            apiUrl = 'accounts/allconversionstatements?statementIdString=' + encodeURIComponent(currentCriteria.statementIdString)
                + '&statementTypeId=' + currentCriteria.statementTypeId
                + '&statementCategoryId=' + currentCriteria.statementCategoryId
                + '&fromMonth=' + currentCriteria.fromMonth
                + '&fromYear=' + currentCriteria.fromYear
                + '&toMonth=' + currentCriteria.toMonth
                + '&toYear=' + currentCriteria.toYear
                + '&operatorName=' + encodeURIComponent(currentCriteria.operatorName)
                + '&operatorNameExact=' + (currentCriteria.operatorNameExact === true)
                + '&ownerNumber=' + encodeURIComponent(currentCriteria.ownerNumber)
                + '&ownerName=' + encodeURIComponent(currentCriteria.ownerName)
                + '&ownerNameExact=' + (currentCriteria.ownerNameExact === true)
                + '&checkNumber=' + encodeURIComponent(currentCriteria.checkNumber)
                + '&checkAmount=' + encodeURIComponent(currentCriteria.checkAmount || '')
                + '&checkDate=' + encodeURIComponent(currentCriteria.checkDate)
                + '&ownerIdString=' + encodeURIComponent(currentCriteria.ownerId)
                + '&statusId=' + currentCriteria.statusId
                + '&skipCount=' + currentCriteria.skipCount
                + '&takeCount=' + currentCriteria.takeCount
                + '&sortBy=' + sortBy
                + '&sortDirection=' + sortDirection;
        } else {
            apiUrl = 'accounts/' + currentAccount.id + '/conversionstatements?statementIdString=' + encodeURIComponent(currentCriteria.statementIdString) + '&statementTypeId=' + currentCriteria.statementTypeId + '&statementCategoryId=' + currentCriteria.statementCategoryId + '&fromMonth=' + currentCriteria.fromMonth + '&fromYear=' + currentCriteria.fromYear + '&toMonth=' + currentCriteria.toMonth + '&toYear=' + currentCriteria.toYear + '&operatorName=' + encodeURIComponent(currentCriteria.operatorName) + '&operatorNameExact=' + (currentCriteria.operatorNameExact === true) + '&ownerNumber=' + encodeURIComponent(currentCriteria.ownerNumber) + '&ownerName=' + encodeURIComponent(currentCriteria.ownerName) + '&ownerNameExact=' + (currentCriteria.ownerNameExact === true) + '&checkNumber=' + encodeURIComponent(currentCriteria.checkNumber) + '&checkAmount=' + encodeURIComponent(currentCriteria.checkAmount || '') + '&checkDate=' + encodeURIComponent(currentCriteria.checkDate) + '&ownerIdString=' + encodeURIComponent(currentCriteria.ownerId) + '&statusId=' + currentCriteria.statusId + '&skipCount=' + currentCriteria.skipCount + '&takeCount=' + currentCriteria.takeCount + '&sortBy=' + sortBy + '&sortDirection=' + sortDirection;
        }

        console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //distinct operator/owner names across all pages for the criteria's account and date range
    const getFilterNames = async (currentCriteria) => {
        const range = currentCriteria.fromMonth + '|' + currentCriteria.fromYear + '|' + currentCriteria.toMonth + '|' + currentCriteria.toYear;
        const dateParams = 'fromMonth=' + currentCriteria.fromMonth + '&fromYear=' + currentCriteria.fromYear + '&toMonth=' + currentCriteria.toMonth + '&toYear=' + currentCriteria.toYear;
        const apiUrl = accountProfile.hasDocConversion
            ? 'accounts/allconversionstatementfilternames?' + dateParams
            : 'accounts/' + currentAccount.id + '/conversionstatementfilternames?' + dateParams;

        try {
            const response = await apiGet(apiUrl, getAccessTokenSilently);
            if (!response.ok) {
                return null;
            }
            const json = await response.json();
            filterNamesRangeRef.current = range;
            return { operatorNames: json.operatorNames || [], ownerNames: json.ownerNames || [] };
        } catch (ex) {
            console.log('Filter names error: ' + ex.message);
            return null;
        }
    };

    const matchesNameSearch = (name, term) =>
        typeof name === 'string' && name.toLowerCase().includes((term || '').toLowerCase());

    const applyFilterNames = (filterNames, opTerm, ownerTerm) => {
        if (!filterNames) {
            return;
        }
        setUnfilteredOperators(filterNames.operatorNames);
        setFilteredOperators(filterNames.operatorNames.filter(op => matchesNameSearch(op, opTerm)));
        setUnfilteredOwners(filterNames.ownerNames);
        setFilteredOwners(filterNames.ownerNames.filter(owner => matchesNameSearch(owner, ownerTerm)));
    };

    const refreshFilterNamesIfRangeChanged = async (currentCriteria) => {
        const range = currentCriteria.fromMonth + '|' + currentCriteria.fromYear + '|' + currentCriteria.toMonth + '|' + currentCriteria.toYear;
        if (range === filterNamesRangeRef.current) {
            return;
        }
        applyFilterNames(await getFilterNames(currentCriteria), searchOpTerm, searchOwnerTerm);
    };

    //get conversion statement categories
    const getStatementCategories = async () => {
        //console.log('Getting Statement Categories...');

        let apiUrl = 'accounts/' + currentAccount.id + '/conversionstatementcategories';
        console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    // Open the Mapping Needed popup for a statement. Fired by clicking the
    // status pill in the table. Calls the MappingNeeds endpoint, populates
    // form state, and opens the modal.
    const handleOpenMappingNeeded = async (statementId, statementIdString) => {
        setMappingNeededStatementId(statementId);
        setMappingNeededStatementIdString(statementIdString || ('Statement ' + statementId));
        setMappingNeededData(null);
        setMappingNeededError('');
        setSenderCodeInput('');
        setProductMappings({});
        setTransactionMappings({});
        setMappingNeededLoading(true);
        setMappingNeededModalShow(true);

        try {
            const apiUrl = 'accounts/' + currentAccount.id + '/Statements/' + statementId + '/MappingNeeds';
            const response = await apiGet(apiUrl, getAccessTokenSilently);

            if (response.status === 204) {
                //Backend says nothing is left to map — closest the popup
                //and refresh the table; the status pill should already be
                //showing Available if this is the case.
                setMappingNeededLoading(false);
                setMappingNeededModalShow(false);
                return;
            }
            if (!response.ok) {
                setMappingNeededError('Failed to load mapping data (HTTP ' + response.status + ').');
                setMappingNeededLoading(false);
                return;
            }

            const json = await response.json();
            setMappingNeededData(json);
            //CDEX Sender Code input is intentionally left blank; the admin
            //types it in fresh each time the popup opens.
            setSenderCodeInput('');

            //Seed editable maps with blank values for every unmapped row.
            const newProductMappings = {};
            const newTransactionMappings = {};
            (json.unmappedProducts || []).forEach(p => {
                newProductMappings[p.dataFileProductCodeId] = { cdexProductCode: '' };
                (p.unmappedTransactions || []).forEach(t => {
                    newTransactionMappings[t.dataFileTransactionCodeId] = { cdexTransactionCode: '', revLineTypeCode: '' };
                });
            });
            setProductMappings(newProductMappings);
            setTransactionMappings(newTransactionMappings);
        } catch (err) {
            console.log('Error loading mapping needs: ' + err.message);
            setMappingNeededError('Error loading mapping data. Please try again.');
        } finally {
            setMappingNeededLoading(false);
        }
    };

    //Refresh the doc conversion table after a successful save — uses the same
    //getStatements call the page already uses for filter/page changes so the
    //row's status pill flips appropriately (Available if both flags clear, or
    //still Mapping Needed if more pieces remain).
    const refreshDocConversionTable = async () => {
        try {
            const response = await getStatements(dataCriteria, sortBy, sortDirection);
            if (response && response.success) {
                setDocuments(response.data.data);
                setRowCount(response.data.rowCount);
            }
        } catch (ex) {
            console.log('Error refreshing doc conversion table: ' + ex.message);
        }
    };

    //Save the entered 2-digit CDEX Sender Code. POSTs to the new save endpoint,
    //then re-fetches MappingNeeds so the popup hides the Sender section (or
    //closes entirely if CDEX is also done) and refreshes the parent table.
    const handleSaveSenderCode = async () => {
        if (!mappingNeededStatementId || !senderCodeInput) return;
        setSavingSenderCode(true);
        try {
            const apiUrl = 'accounts/' + currentAccount.id + '/Statements/' + mappingNeededStatementId + '/SaveSenderCode';
            const body = JSON.stringify({ cdexOperatorCode: senderCodeInput });
            const response = await apiPost(apiUrl, body, true, getAccessTokenSilently);
            if (!response.ok) {
                const text = await response.text();
                setMappingNeededError(text || ('Sender code save failed (HTTP ' + response.status + ').'));
                setSavingSenderCode(false);
                return;
            }
            //Re-fetch MappingNeeds so the popup re-renders without the Sender
            //section (and potentially closes if nothing else is needed).
            await reloadMappingNeeds();
            await refreshDocConversionTable();
        } catch (ex) {
            console.log('Sender code save error: ' + ex.message);
            setMappingNeededError('Error saving sender code. Please try again.');
        } finally {
            setSavingSenderCode(false);
        }
    };

    //Save the entered product / transaction CDEX codes. POSTs the edited
    //rows only — backend will skip any entry where the user left both
    //fields blank.
    const handleSaveCdexCodes = async () => {
        if (!mappingNeededStatementId) return;
        setSavingCdexCodes(true);
        try {
            //Flatten the in-progress edits into a list of products with their
            //transactions, exactly matching the MappingNeedsDTO shape so the
            //backend can mirror it on the save side.
            const products = (mappingNeededData?.unmappedProducts || []).map(p => ({
                dataFileProductCodeId: p.dataFileProductCodeId,
                productCode: p.productCode,
                productDesc: p.productDesc,
                cdexProductCode: (productMappings[p.dataFileProductCodeId]?.cdexProductCode || ''),
                unmappedTransactions: (p.unmappedTransactions || []).map(t => ({
                    dataFileTransactionCodeId: t.dataFileTransactionCodeId,
                    transactionCode: t.transactionCode,
                    transactionDesc: t.transactionDesc,
                    cdexTransactionCode: (transactionMappings[t.dataFileTransactionCodeId]?.cdexTransactionCode || ''),
                    revLineTypeCode: (transactionMappings[t.dataFileTransactionCodeId]?.revLineTypeCode || '')
                }))
            }));

            const apiUrl = 'accounts/' + currentAccount.id + '/Statements/' + mappingNeededStatementId + '/SaveCdexMappings';
            const body = JSON.stringify({ products });
            const response = await apiPost(apiUrl, body, true, getAccessTokenSilently);
            if (!response.ok) {
                const text = await response.text();
                setMappingNeededError(text || ('CDEX codes save failed (HTTP ' + response.status + ').'));
                setSavingCdexCodes(false);
                return;
            }
            await reloadMappingNeeds();
            await refreshDocConversionTable();
        } catch (ex) {
            console.log('CDEX codes save error: ' + ex.message);
            setMappingNeededError('Error saving CDEX codes. Please try again.');
        } finally {
            setSavingCdexCodes(false);
        }
    };

    //Re-fetch MappingNeeds after a successful partial save. If both flags
    //are now false (204 from backend), close the popup automatically.
    const reloadMappingNeeds = async () => {
        if (!mappingNeededStatementId) return;
        try {
            const apiUrl = 'accounts/' + currentAccount.id + '/Statements/' + mappingNeededStatementId + '/MappingNeeds';
            const response = await apiGet(apiUrl, getAccessTokenSilently);
            if (response.status === 204) {
                setMappingNeededModalShow(false);
                return;
            }
            if (response.ok) {
                const json = await response.json();
                setMappingNeededData(json);
                //Reset only the saved-side input(s). Easiest: reseed both.
                //CDEX Sender Code input is intentionally left blank on re-fetch
                //as well — no pre-populate.
                setSenderCodeInput('');
                const newProductMappings = {};
                const newTransactionMappings = {};
                (json.unmappedProducts || []).forEach(p => {
                    newProductMappings[p.dataFileProductCodeId] = { cdexProductCode: '' };
                    (p.unmappedTransactions || []).forEach(t => {
                        newTransactionMappings[t.dataFileTransactionCodeId] = { cdexTransactionCode: '', revLineTypeCode: '' };
                    });
                });
                setProductMappings(newProductMappings);
                setTransactionMappings(newTransactionMappings);
            }
        } catch (ex) {
            console.log('Reload mapping needs error: ' + ex.message);
        }
    };

    const handleOpenExceptionAction = (statementId, statementIdString) => {
        setExceptionActionStatementId(statementId);
        setExceptionActionStatementIdString(statementIdString || ('' + statementId));
        setExceptionActionBusy(null);
        setExceptionActionCompleted(null);
        setExceptionActionError('');
        setExceptionActionWarning('');
        setExceptionActionSuccess('');
        setExceptionConfirmingDelete(false);
        setExceptionActionModalShow(true);
    };

    //Both endpoints return { success, message, warningMessage }; failed rule
    //checks come back as success = false with the reason to display.
    const runExceptionAction = async (action) => {
        if (!exceptionActionStatementId) return;
        setExceptionActionBusy(action);
        setExceptionActionError('');
        try {
            const endpoint = action === 'delete' ? 'a_import/DeleteConversionStatement' : 'a_import/RerunConversionStatement';
            const apiUrl = endpoint + '?statementId=' + exceptionActionStatementId;
            const response = await apiPost(apiUrl, null, true, getAccessTokenSilently);
            if (!response || !response.ok) {
                setExceptionActionError('The request failed' + (response ? ' (HTTP ' + response.status + ')' : '') + '. Please try again.');
                return;
            }
            const json = await response.json();
            if (!json.success) {
                setExceptionActionError(json.message || 'The request failed.');
                return;
            }
            setExceptionActionCompleted(action);
            setExceptionActionSuccess(json.message || (action === 'delete' ? 'Statement deleted' : 'Statement queued for re-run'));
            setExceptionActionWarning(json.warningMessage || '');
            await refreshDocConversionTable();
        } catch (ex) {
            console.log('Exception action error: ' + ex.message);
            setExceptionActionError('The request failed. Please try again.');
        } finally {
            setExceptionActionBusy(null);
        }
    };

    const handleAddCategory = async () => {

        //set api url
        const apiUrl = 'accounts/statementCategory';
        const body = { accountId: currentAccount.id, categoryCode: newCategory.categoryCode, categoryName: newCategory.categoryName };

        //console.log(apiUrl);

        let statementAdded = false;
        let newCategoryId = 0;
        try {
            await addStatementCategory(apiUrl, body).then(response => {
                if (response.success) {
                    if (response.data.id === 0) {
                        setNewCategory({
                            ...newCategory,
                            exceptionMessage: response.data.exceptionMessage
                        });
                    } else {
                        newCategoryId = response.data.id;
                        statementAdded = true;
                    }
                } else {
                    throw 'Failed:', response.statusText + ' : ' + response;
                }
            });

            if (statementAdded === true) {
                await getStatementCategories().then(response => {
                    if (response.success) {
                        setStatementCategories(response.data);

                        if (documentInputModalShow === true) {
                            setNewItemCriteria({
                                ...newItemCriteria,
                                statementCategoryId: newCategoryId
                            });
                        } else {
                            setDataCriteria({
                                ...dataCriteria,
                                statementCategoryId: newCategoryId
                            });
                        }

                        setNewCategory({
                            id: 0,
                            categoryCode: '',
                            categoryName: '',
                            exceptionMessage: ''
                        });

                        setAlertShow(true);
                        setAlertVariant('success');
                        setAlertMessage('Success!  ' + newCategory.categoryCode + ' - ' + newCategory.categoryName + ' was added.');      
                        
                    } else {

                        setNewCategory({
                            id: 0,
                            categoryCode: '',
                            categoryName: '',
                            exceptionMessage: ''
                        });

                        throw 'Failed:', response.statusText + ' : ' + response;
                    }

                    setCategoryAddModalShow(false);
                });
            }
        }
        catch (ex) {
            console.error('Error:', ex);
            //setDataErrors(ex.message);
            //setDataStatus('error');

            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage('Unknown error occurred. Failed to add Org.');
        }
        finally {
            setTimeout(() => {
                setAlertShow(false);
            }, 5000);
        }
    }

    //add statement category
    const addStatementCategory = async (apiUrl, body) => {
        //console.log('Getting User Profile...');

        console.log(apiUrl);
        const jsonBody = JSON.stringify(body);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPost(apiUrl, jsonBody, true, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Data: ' + json);

        return { success: response.ok, data: json };
    }

    const handleItemCategoryChange = async (event, statementId, sequenceNumber) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const statementCategoryId = event.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + statementCategoryId);

        setCategoryChangeCriteria({
            statementId: statementId,
            sequenceNumber: sequenceNumber,
            statementCategoryId: statementCategoryId,
            updateAllItems: false
        })

        //get count of items with this statementid
        const statementCount = documents.filter((doc) => doc.statementId === statementId).length;

        if (statementCount === 1) {
            await saveItemCategoryChange(statementId, sequenceNumber, statementCategoryId, false);            
        } else {
            setCategoryChangeConfirmationModalShow(true);
        }
    }

    const saveItemCategoryChange = async (statementId, sequenceNumber, statementCategoryId, updateAllItems) => {        

        setDataStatus('loading');
        setCategoryChangeConfirmationModalShow(false);

        //set api url
        const apiUrl = 'accounts/statementItemCategory';
        const body = { statementId: statementId, sequenceNumber: sequenceNumber, statementCategoryId: statementCategoryId, updateAllItems: updateAllItems };

        //console.log(apiUrl);

        let categoryUpdated = false;
        try {
            await updateStatementItemCategory(apiUrl, body).then(response => {
                if (response.success) {

                    setCategoryEditItem(null);
                    categoryUpdated = true;

                } else {
                    throw 'Failed:', response.statusText + ' : ' + response;
                }
            });

            if (categoryUpdated === true) {
                await getStatements(dataCriteria, sortBy, sortDirection).then(response => {
                    if (response.success) {
                        setDocuments(response.data.data);
                        setRowCount(response.data.rowCount);
                    }
                });
            }

            setDataStatus('ready');
        }
        catch (ex) {
            console.error('Error:', ex);
            setDataErrors(ex.message);
            setDataStatus('error');

            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage('Unknown error occurred. Failed to update Org.');
        }
        finally {
            setTimeout(() => {
                setAlertShow(false);
            }, 5000);
        }
    }

    //add statement category
    const updateStatementItemCategory = async (apiUrl, body) => {
        //console.log('Getting User Profile...');

        console.log(apiUrl);
        const jsonBody = JSON.stringify(body);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok);

        return { success: response.ok };
    }

    //get operators (operators this account can receive check statements from - ie. not operators "managed by this account")
    const getOperators = async () => {
        //console.log('Getting Operators...');

        console.log('AccountId: ' + currentAccount.id);

        let apiUrl = 'accounts/' + currentAccount.id + '/checksenders';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //get doc conversion network type
    const getDocConversionNetworkType = async () => {
        //console.log('Getting DocConversionNetworkType...');

        console.log('AccountId: ' + currentAccount.id);

        let apiUrl = 'accounts/' + currentAccount.id + '/docconversionnetworktype';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //get doc conversion network type
    const getDocConversionOutputType = async () => {
        //console.log('Getting DocConversionNetworkType...');

        console.log('AccountId: ' + currentAccount.id);

        let apiUrl = 'accounts/' + currentAccount.id + '/docconversionoutputtype';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //get owners (owners managed by this account)
    const getOwners = async () => {
        //console.log('Getting Owners...');

        console.log('AccountId: ' + currentAccount.id);

        const apiUrl = 'accounts/' + currentAccount.id + '/managedreceivers';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    //handle search form control changes
    const handleChange = (e) => {
        const { name, value, tagName } = e.target;

        const newCriteria = { ...dataCriteria, [name]: value };
        setDataCriteria(newCriteria);

        //if came from listed name, auto-search
        if (['statusId', 'statementTypeId', 'operatorName', 'statementCategoryId', 'ownerName'].includes(name)) {
            runSearch({ [name]: value }); 
        }
    };

    //handle input form control changes
    const handleInputChange = (event) => {
        //event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;

        console.log('Field: ' + fieldName + ', Value: ' + value);

        setNewItemCriteria({
            ...newItemCriteria,
            [fieldName]: value
        });

        if (fieldName === 'deliveryEmail') {
            //***************Begin - Email************//
            var validEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
            const emailMatchFound = value.search(validEmail);
            const isEmailValid = emailMatchFound > -1;
            setIsEmailValid(isEmailValid);
            //***************End - Email**************//
        }
    }

    //handle category form control changes
    const handleCategoryInputChange = (event) => {
        //event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;

        console.log('Field: ' + fieldName + ', Value: ' + value);

        setNewCategory({
            ...newCategory,
            [fieldName]: value,
            exceptionMessage: ''
        });

        if (fieldName === 'categoryCode') {
            setIsCategoryCodeValid(value.length < 1 ? false : true);
        }

        if (fieldName === 'categoryName') {
            setIsCategoryNameValid(value.length < 1 ? false : true);
        }
    }

    //handle sort link changes
    const handleSortChange = async (linkSortBy) => {
        //event.preventDefault();

        console.log('Sort By: ' + linkSortBy);

        let newSortBy = linkSortBy;
        let newSortDirection = 'Ascending';
        if (sortBy === newSortBy) {
            newSortDirection = sortDirection === 'Ascending' ? 'Descending' : 'Ascending';
            setSortDirection(newSortDirection);
        } else {
            setSortBy(newSortBy);
            setSortDirection(newSortDirection)
        }

        setDataStatus('loading');

        setCurrentPage(1);

        const currentCriteria = {
            ...dataCriteria,
            skipCount: 0
        };

        await getStatements(currentCriteria, newSortBy, newSortDirection)
            .then(response => {
                if (response.data.data.length === 0) {
                    setDocuments([]);
                    setRowCount(0);
                    setDataStatus('nodata');
                } else {
                    setDocuments(response.data.data);
                    setRowCount(response.data.rowCount);
                    setDataStatus('ready');
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    }

    //const handleKeypress = async (event) => {
    //    //event.preventDefault();

    //    //newline if enter key was pressed
    //    if (event.key === 'Enter') {
    //        event.preventDefault();

    //        //this doesn't work
    //        const fieldName = event.target.name;
    //        const value = event.target.value + '\n';

    //        console.log('Field: ' + fieldName + ', Value: ' + value);

    //        setNewItemCriteria({
    //            ...newItemCriteria,
    //            [fieldName]: value
    //        });
    //    }
    //};
    
    //handle file input control changes
    const handlefileInputChange = (event) => {
        //event.preventDefault();

        const fieldName = event.target.files[0];
        const value = event.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + value);

        setNewItemCriteria({
            ...newItemCriteria,
            selectedFile: event.target.files[0]
        });
    }

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setDragging(false);
    };

    //handle drag and drop event
    const handleDrop = (e) => {
        e.preventDefault();

        var newFiles = [];
        var files = e.target.files || (e.dataTransfer && e.dataTransfer.files);

        const yo = uploadFiles;
        let excludeFile = false;
        for (var i = 0; i < files.length; i++) {

            //make sure file isn't already in list
            excludeFile = false;
            for (var j = 0; j < uploadFiles.length; j++) {
                if (files[i].name === uploadFiles[j].name) {
                    excludeFile = true;
                    break;
                }
            }

            if (docConversionNetworkType == 2) {
                if (!files[i].name.toLowerCase().endsWith('.pdf')) {
                    excludeFile = true;
                }
            } else {
                if (!files[i].name.toLowerCase().endsWith('.pdf')
                    && !files[i].name.toLowerCase().endsWith('.tif')
                    && !files[i].name.toLowerCase().endsWith('.tiff')
                    && !files[i].name.toLowerCase().endsWith('.xlsx')
                    && !files[i].name.toLowerCase().endsWith('.xls')) {
                    excludeFile = true;
                }
            }

            if (!excludeFile) {
                newFiles.push(files[i]);
            }
        }
        setUploadFiles((prevFiles) => [...prevFiles, ...newFiles]);

        e.target.value = null;
        setDragging(false);
    }

    const handleRemoveFile = (index) => {
        setUploadFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    //handle file upload
    const handleFileUpload = () => {

        const date = new Date();
        const currMonth = date.getMonth() + 1;
        const currDay = date.getDate();
        const currYear = date.getFullYear();
        const stringCurrDate = currMonth + '/' + currDay + '/' + currYear;

        //const newDocument = { id: 4, statementType: (newItemCriteria.statementTypeId == 1 ? 'Revenue' : (newItemCriteria.statementTypeId == 2 ? 'JIB' : 'Plant')), deliveryTime: (newItemCriteria.deliveryTimeId == 1 ? 'Standard (3 days)' : 'Rush (1 day)'), deliveryEmail: newItemCriteria.deliveryEmail, status: 'Pending', receivedDate: stringCurrDate, statusDate: stringCurrDate };
        //const newDocument = { statementId: 1000, statementType: (newItemCriteria.statementTypeId == 1 ? 'Revenue' : (newItemCriteria.statementTypeId == 2 ? 'JIB' : 'Plant')), operatorName: '', ownerName: '', checkNumber: '', checkDate: '', checkAmount: '', deliveryTime: (newItemCriteria.deliveryTimeId == 1 ? 'Standard (3 days)' : 'Rush (1 day)'), deliveryEmail: newItemCriteria.deliveryEmail, status: 'Pending', receivedDate: stringCurrDate, statusDate: stringCurrDate };
        const newDocument = { statementId: 1000, statementType: (newItemCriteria.statementTypeId == 1 ? 'Revenue' : (newItemCriteria.statementTypeId == 2 ? 'JIB' : 'Plant')), operatorName: 'SOUTHWOODS OPERATING LLC', ownerName: 'STEAMBOAT ENERGY LLC', checkNumber: '8000855', checkDate: '11/25/2023', checkAmount: '$122.76', deliveryTime: (newItemCriteria.deliveryTimeId == 1 ? 'Standard (3 days)' : 'Rush (1 day)'), deliveryEmail: newItemCriteria.deliveryEmail, specialInstructions: '', status: 'Pending', receivedDate: stringCurrDate, statusDate: stringCurrDate };
        documents.push(newDocument);
        setDocuments(documents);

        setDocumentInputModalShow(false);
        setDocumentUploadModalShow(false);

        setAlertVariant('success');
        setAlertMessage('Success!  An email was sent to ' + newItemCriteria.deliveryEmail + ' confirming document receipt. Please check email for further details.');
        setAlertShow(true);

        setNewItemCriteria({
            statementTypeId: 1,
            deliveryTimeId: 1,
            statementCategoryId: 0,
            deliveryEmail: '',    //user.email,
            specialInstructions: '',
            selectedFile: null,
            uploadFiles: []
        });
        setUploadFiles([]);
        setIsEmailValid(true);

        setTimeout(() => {
            setAlertShow(false);
        }, 8000);
    }

    //search criteria helper so drop down items can call a search
    const runSearch = async (criteriaOverride = {}) => {
        setDataStatus('loading');

        setCurrentPage(1);

        const currentCriteria = {
            ...dataCriteria,
            ...criteriaOverride,
            skipCount: 0
        };

        refreshFilterNamesIfRangeChanged(currentCriteria);

        await getStatements(currentCriteria, sortBy, sortDirection)
            .then(response => {
                if (response.data.data.length === 0) {
                    setDocuments([]);
                    setRowCount(0);
                    setDataStatus('nodata');
                } else {
                    setDocuments(response.data.data);
                    setRowCount(response.data.rowCount);
                    setDataStatus('ready');
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //handle form submit
    const submitForm = async (e) => {
        e.preventDefault();
        runSearch();
    };

    const handleResetFilters = () => {
        const dates = getDates();

        setSearchOpTerm('');
        setSearchOwnerTerm('');
        setSearchCatTerm('');

        applyOperatorFilter('');
        applyOwnerFilter('');
        applyCatFilter('');

        setDataCriteria(prev => ({
            ...prev,
            skipCount: 0,
            takeCount: 50,
            statementIdString: '',
            statementTypeId: 0,
            statementCategoryId: 0,
            operatorName: '',
            operatorNameExact: false,
            ownerNumber: '',
            ownerName: '',
            ownerNameExact: false,
            checkNumber: '',
            checkAmount: '',
            statusId: 0,
            fromMonth: dates.fromMonth,
            fromYear: dates.fromYear,
            toMonth: dates.currMonth,
            toYear: dates.currYear,
            ownerId: '',
            checkDate: ''

        }));

        
        setCurrentPage(1);
        setCategoryEditItem(null);
        //setStatusFilter("");        // if you store it separately

        runSearch({
            skipCount: 0,
            takeCount: 50,
            statementIdString: '',
            statementTypeId: 0,
            statementCategoryId: 0,
            operatorName: '',
            operatorNameExact: false,
            ownerNumber: '',
            ownerName: '',
            ownerNameExact: false,
            checkNumber: '',
            checkAmount: '',
            statusId: 0,
            fromMonth: dates.fromMonth,
            fromYear: dates.fromYear,
            toMonth: dates.currMonth,
            toYear: dates.currYear,
            ownerId: '',
            checkDate: ''
        });
    };


    //********************************************Begin - Document Upload********************************************//

    const handleBlobUpload = async () => {
        setDataStatus('uploading')

        setDocumentInputModalShow(false);
        setDocumentUploadModalShow(false);

        try {
            //reset progress indicator
            setProgressStatus(0);

            const inputFileNameArray = uploadFiles.map((uploadFile, index) => {
                return { inputFileName: uploadFile.name, blobSAS: '' };
            });

            //const initializeBlobDTO = { accountId: currentAccount.id, statementTypeId: newItemCriteria.statementTypeId, DeliveryTimeId: newItemCriteria.deliveryTimeId, DeliveryEmail: newItemCriteria.deliveryEmail, SpecialInstructions: newItemCriteria.specialInstructions, blobFiles: [{ inputFileName: 'File1', blobSAS: '' }, { inputFileName: 'File2', blobSAS: '' }, { inputFileName: 'File3', blobSAS: '' }] };
            const initializeBlobDTO = { accountId: currentAccount.id, statementTypeId: newItemCriteria.statementTypeId, DeliveryTimeId: newItemCriteria.deliveryTimeId, StatementCategoryId: newItemCriteria.statementCategoryId, DeliveryEmail: newItemCriteria.deliveryEmail, SpecialInstructions: newItemCriteria.specialInstructions, blobFiles: inputFileNameArray };

            //create blob and get sas uri
            let blobSASUri = null;
            let blobFileName = null;
            let blobFiles = null;
            await initializeBlobMultiple(initializeBlobDTO)
                .then(response => {
                    if (response.success) {
                        blobFiles = response.data.blobFiles;
                        //continue to uploadBlob below...
                    }
                    else {
                        throw 'Failed:', response.statusText + ' : ' + response;
                    }
                });

            for (var i = 0; i < blobFiles.length; i++) {
                blobSASUri = blobFiles[i].blobSAS;
                blobFileName = blobFiles[i].inputFileName;
                const blobFile = uploadFiles[i];

                //uploadBlob                
                await uploadBlobMultiple(blobSASUri, blobFile)
                    .then(response => {
                        if (response.success) {
                            //continue to createImportProcess below...
                        }
                        else {
                            throw 'Failed:', response.statusText + ' : ' + response;
                        }
                    });

                //createImportProcess
                await createConversionProcess(blobFileName)
                    .then(response => {
                        if (response.success) {
                            //console.log('Success:', response.success);
                            
                        }
                        else {
                            throw 'Failed:', response.statusText + ' : ' + response;
                        }
                    });                
            }

            //setDataStatus('ready');
            setAlertMessage('Success!  An email was sent to ' + newItemCriteria.deliveryEmail + ' confirming document receipt. Please check email for further details.');
            setAlertShow(true);
            setAlertVariant('success');

            //setDataStatus('loading');
            await getStatements(dataCriteria, sortBy, sortDirection)
                .then(response => {
                    if (response.data.data.length === 0) {
                        setDocuments([]);
                        setRowCount(0);
                        setDataStatus('nodata');
                    } else {
                        setDocuments(response.data.data);
                        setRowCount(response.data.rowCount);
                        setDataStatus('ready');
                    }
                })
        }
        catch (ex) {
            console.error('Error:', ex);
            setDataErrors(ex.message);
            setDataStatus('error');

            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage('Upload failed.');
        }
        finally {
            //reset file selection and criteria
            setNewItemCriteria({
                statementTypeId: 1,
                deliveryTimeId: 1,
                statementCategoryId: 0,
                deliveryEmail: '',    //user.email,
                specialInstructions: '',
                selectedFile: null,
                uploadFiles: []
            });
            setUploadFiles([]);
            setIsEmailValid(true);
            //setIsFilePicked(false);

            //set the alert to close after 10 seconds
            setTimeout(() => {
                setAlertShow(false);
            }, 10000);
        }

        return { success: true };
    };

    //const handleBlobUpload_SINGLEBAK = async () => {
    //    setDataStatus('uploading')

    //    setDocumentInputModalShow(false);
    //    setDocumentUploadModalShow(false);

    //    try {
    //        //reset progress indicator
    //        setProgressStatus(0);

    //        //create blob and get sas uri
    //        let blobSASUri = null;
    //        let blobFileName = null;
    //        await initializeBlob()
    //            .then(response => {
    //                if (response.success) {
    //                    blobSASUri = response.data.blobSASUriString;
    //                    blobFileName = response.data.blobFileName;
    //                    //continue to uploadBlob below...
    //                }
    //                else {
    //                    throw 'Failed:', response.statusText + ' : ' + response;
    //                }
    //            });

    //        //uploadBlob
    //        await uploadBlob(blobSASUri)
    //            .then(response => {
    //                if (response.success) {
    //                    //continue to createImportProcess below...
    //                }
    //                else {
    //                    throw 'Failed:', response.statusText + ' : ' + response;
    //                }
    //            });

    //        //createImportProcess
    //        await createConversionProcess(blobFileName)
    //            .then(response => {
    //                if (response.success) {
    //                    console.log('Success:', response.success);
    //                    setDataStatus('ready');

    //                    setAlertMessage('Success!  An email was sent to ' + newItemCriteria.deliveryEmail + ' confirming document receipt. Please check email for further details.');
    //                    setAlertShow(true);
    //                    setAlertVariant('success');
    //                }
    //                else {
    //                    throw 'Failed:', response.statusText + ' : ' + response;
    //                }
    //            });

    //        //TODO: need review and add this
    //        ////refresh document list
    //        //setDataStatus('loading');
    //        //await getStatements()
    //        //    .then(response => {
    //        //        if (response.success) {
    //        //            console.log('Success:', response.success);
    //        //            setDataStatus('ready');

    //        //            setDocuments(response.documents.data);
    //        //            setRowCount(response.documents.data.length);
    //        //        }
    //        //        else {
    //        //            throw 'Failed:', response.statusText + ' : ' + response;
    //        //        }
    //        //    });
    //    }
    //    catch (ex) {
    //        console.error('Error:', ex);
    //        setDataErrors(ex.message);
    //        setDataStatus('error');

    //        setAlertShow(true);
    //        setAlertVariant('danger');
    //        setAlertMessage('Upload failed.');
    //    }
    //    finally {
    //        //reset file selection and criteria
    //        setNewItemCriteria({
    //            statementTypeId: 1,
    //            deliveryTimeId: 1,
    //            deliveryEmail: '',    //user.email,
    //            specialInstructions: '',
    //            selectedFile: null,
    //            uploadFiles: []
    //        });
    //        //setIsFilePicked(false);

    //        //set the alert to close after 10 seconds
    //        setTimeout(() => {
    //            setAlertShow(false);
    //        }, 10000);
    //    }

    //    return { success: true };
    //};

    ////initialize the blob and get the blob sas uri
    //const initializeBlob_SINGLEBACK = async () => {
    //    //console.log('Getting SAS Uri...');

    //    const apiUrl = 'a_import/createconversionblob?accountId=' + currentAccount.id + '&inputFileName=' + newItemCriteria.selectedFile.name + '&statementTypeId=' + newItemCriteria.statementTypeId + '&deliveryTimeId=' + newItemCriteria.deliveryTimeId + '&deliveryEmail=' + newItemCriteria.deliveryEmail + '&specialInstructions=' + newItemCriteria.specialInstructions;
    //    //console.log(apiUrl);

    //    const response = await apiGet(apiUrl, getAccessTokenSilently);
    //    const resultString = await response.text();
    //    const json = JSON.parse(resultString);
    //    console.log('Response - Status: ' + response.status + ', Success: ' + response.ok, ', Json: ' + JSON.stringify(json));

    //    return { success: response.ok, data: json };
    //}

    //initialize the blobs and get the blob sas uri's
    const initializeBlobMultiple = async (initializeBlobDTO) => {

        const apiUrl = 'a_import/createconversionblobmultiple';
        const jsonBody = JSON.stringify(initializeBlobDTO);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    ////upload blob using sas
    //const uploadBlob_SINGLEBACK = async (sasTokenUrl) => {
    //    console.log('Uploading blob...');

    //    const blockBlobClient = new BlockBlobClient(sasTokenUrl);
    //    setProgressStatus(0);
    //    const response = await blockBlobClient.uploadBrowserData(newItemCriteria.selectedFile, {
    //        blockSize: 4 * 1024 * 1024,
    //        concurrency: 20,
    //        onProgress: ev => setProgressStatus(Math.floor((ev.loadedBytes / newItemCriteria.selectedFile.size) * 100))
    //    })
    //        .then((result) => {
    //            return { success: true };
    //        })
    //        .catch((ex) => {
    //            return { success: false, statusText: ex.message };
    //        });

    //    return response;
    //};

    //upload blob using sas
    const uploadBlobMultiple = async (sasTokenUrl, selectedFile) => {
        console.log('Uploading blob...');

        const blockBlobClient = new BlockBlobClient(sasTokenUrl);
        setProgressStatus(0);
        const response = await blockBlobClient.uploadBrowserData(selectedFile, {
            blockSize: 4 * 1024 * 1024,
            concurrency: 20,
            onProgress: ev => setProgressStatus(Math.floor((ev.loadedBytes / selectedFile.size) * 100))
        })
            .then((result) => {
                return { success: true };
            })
            .catch((ex) => {
                return { success: false, statusText: ex.message };
            });

        return response;
    };

    //create conversion process
    const createConversionProcess = async (blobFileName) => {
        //console.log('Creating import process...');

        const apiUrl = 'a_import/createconversionprocess?accountId=' + currentAccount.id + '&inputFileName=' + encodeURIComponent(blobFileName) + '&blobFileName=' + encodeURIComponent(blobFileName) + '&statementTypeId=' + newItemCriteria.statementTypeId + '&deliveryTimeId=' + newItemCriteria.deliveryTimeId + '&statementCategoryId=' + parseInt(newItemCriteria.statementCategoryId) + '&deliveryEmail=' + newItemCriteria.deliveryEmail + '&specialInstructions=' + encodeURIComponent(newItemCriteria.specialInstructions);
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok);

        return { success: response.ok };
    }

    //render blob uploading
    const showBlobUploading = () => {
        return (
            <>
                <Row>
                    <p><b>{(progressStatus == 0 ? 'Preparing to upload...' : (progressStatus == 100 ? 'Completing upload...' : ''))}</b></p>
                    <ProgressBar animated now={progressStatus} label={`${progressStatus}%`} />
                </Row>
                <Row>
                    <Spinner
                        animation="border"
                        style={{ width: '5rem', height: '5rem', color: COLORS.gold }}
                    />
                </Row>
            </>
        );
    }

    //*********************************************End - Document Upload*********************************************//

    //*********************************************Begin - Document Download*****************************************//

    // Fetch a single file as a blob without triggering a browser download,
    // mirroring the routing rules used by the per-row buttons.
    const fetchBlobBySasUri = async (statementId, sequenceId) => {
        const uriResp = await getStatementDownloadUri(statementId, sequenceId);
        if (!uriResp.success) throw new Error('Failed to get download URI');
        const blockBlobClient = new BlockBlobClient(uriResp.data.statementDownloadUri);
        const downloadResponse = await blockBlobClient.download();
        const blob = await downloadResponse.blobBody;
        return { blob, fileName: uriResp.data.statementBlobName };
    };

    const fetchBlobByExportApi = async (statementId, apiFormat, inputFileName) => {
        const endpointMap = {
            excel: { endpoint: 'a_export/ExcelByStatement', extension: 'xlsx' },
            jib:   { endpoint: 'a_export/JibByStatement',   extension: 'xlsx' },
            cdex:  { endpoint: 'a_export/CDEXByStatement',  extension: 'dat'  },
        };
        const cfg = endpointMap[apiFormat];
        if (!cfg) throw new Error('Unknown export format: ' + apiFormat);
        const url = cfg.endpoint + '?statementId=' + statementId + '&flagGenerated=true';
        const response = await apiGet(url, getAccessTokenSilently);
        if (!response || !response.ok) throw new Error('Export failed: ' + (response ? response.status : 'no response'));
        const blob = await response.blob();
        const base = inputFileName ? inputFileName.replace(/\.[^/.]+$/, '') : `Statement_${statementId}`;
        return { blob, fileName: `${base}.${cfg.extension}` };
    };

    // Resolves the right fetch path for a (document, format) pair using the same
    // routing logic as handleExcelClick / handleCdexClick in the cell.
    const fetchSingleDocument = async (doc, format) => {
        const hasDataFile = doc.dataFileId != null;
        const isRevenue = doc.statementTypeId === 1;
        const isJib = doc.statementTypeId === 2;

        if (format === 'pdf') {
            return await fetchBlobBySasUri(doc.statementId, 0);
        }
        if (format === 'excel') {
            if (!hasDataFile) return await fetchBlobBySasUri(doc.statementId, doc.sequenceNumber);
            if (isRevenue)    return await fetchBlobByExportApi(doc.statementId, 'excel', doc.inputFileName);
            if (isJib)        return await fetchBlobByExportApi(doc.statementId, 'jib', doc.inputFileName);
        }
        if (format === 'cdex') {
            if (!hasDataFile) return await fetchBlobBySasUri(doc.statementId, doc.sequenceNumber);
            return await fetchBlobByExportApi(doc.statementId, 'cdex', doc.inputFileName);
        }
        throw new Error('Unsupported format: ' + format);
    };

    // Batch: fetch every checked file's blob, stuff them into one ZIP, and
    // trigger a single download. Errors per-item are collected and surfaced.
    const handleDownloadSelected = async () => {
        if (selectedDownloads.size === 0) return;
        setDataStatus('loading');
        try {
            const zip = new JSZip();
            // Format is determined by account type:
            //  - IMTS  (docConversionNetworkType === 1) → always 'cdex' (no XLS for IMTS).
            //  - CDEX  (docConversionOutputType === 2)  → use whatever the dropdown is set to.
            //  - else  (XLS-only)                      → always 'excel'.
            const effectiveFormat = docConversionNetworkType === 1
                ? 'cdex'
                : (docConversionOutputType === 2 ? groupDownloadFormat : 'excel');
            // Pull doc snapshots stored at selection time — no dependency on the current page.
            const items = Array.from(selectedDownloads.values()).map(snap => ({ ...snap, format: effectiveFormat }));
            const extByFormat = { pdf: 'pdf', excel: 'xlsx', cdex: 'dat' };
            const errors = [];
            const zipNames = new Set();
            const dedupeZipName = (name) => {
                if (!zipNames.has(name)) { zipNames.add(name); return name; }
                const dot = name.lastIndexOf('.');
                const stem = dot === -1 ? name : name.slice(0, dot);
                const ext  = dot === -1 ? ''   : name.slice(dot);
                let i = 1;
                let candidate;
                do { candidate = `${stem} (${i++})${ext}`; } while (zipNames.has(candidate));
                zipNames.add(candidate);
                return candidate;
            };
            const succeededKeys = new Set();
            for (const item of items) {
                try {
                    const { blob, fileName } = await fetchSingleDocument(item, item.format);
                    const base = item.inputFileName ? item.inputFileName.replace(/\.[^/.]+$/, '') : `Statement_${item.statementId}`;
                    const rawName = fileName && fileName.trim() !== ''
                        ? fileName
                        : `${base}.${extByFormat[item.format] || 'bin'}`;
                    const safeName = dedupeZipName(rawName);
                    console.log('[batch download] adding to zip:', { item, fileName: safeName, blobSize: blob?.size });
                    zip.file(safeName, blob);
                    //pdf fetches the seq-0 source document, which never affects item status
                    if (item.format !== 'pdf') {
                        succeededKeys.add(`${item.statementId}-${item.sequenceNumber}`);
                    }
                } catch (e) {
                    console.error('[batch download] fetch failed for', item, e);
                    errors.push(`${item.statementId} ${item.format}: ${e.message}`);
                }
            }

            //flip succeeded items to Downloaded locally; the server persisted the same change
            if (!accountProfile.hasDocConversion && !accountProfile.isAdmin && !accountProfile.hasImpersonate) {
                setDocuments(prev => prev.map(doc =>
                    doc.sequenceNumber > 0
                        && succeededKeys.has(`${doc.statementId}-${doc.sequenceNumber}`)
                        && (doc.statusId === 2 || doc.statusId === 3)
                        ? { ...doc, statusId: 3, statusString: 'Downloaded' }
                        : doc
                ));
            }
            // Build zip filename: doc_cov_mmddyy_<seq>.zip
            const now = new Date();
            const mm = String(now.getMonth() + 1).padStart(2, '0');
            const dd = String(now.getDate()).padStart(2, '0');
            const yy = String(now.getFullYear()).slice(-2);
            const zipName = `doc_cov_${mm}${dd}${yy}_${batchDownloadSeq}.zip`;
            setBatchDownloadSeq(prev => prev + 1);

            const zipBlob = await zip.generateAsync({ type: 'blob' });
            const fileURL = window.URL.createObjectURL(zipBlob);
            const alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = zipName;
            alink.click();
            window.URL.revokeObjectURL(fileURL);

            if (errors.length) {
                console.warn('Batch download errors:', errors);
                setAlertVariant('warning');
                setAlertMessage(`Downloaded ZIP with ${errors.length} error(s) — see console.`);
            } else {
                setAlertVariant('success');
                setAlertMessage(`Downloaded ${items.length} item(s) as ZIP.`);
            }
            setAlertShow(true);
            setSelectedDownloads(new Map());
        } catch (e) {
            console.error(e);
            setAlertVariant('danger');
            setAlertMessage('Batch download failed: ' + e.message);
            setAlertShow(true);
        } finally {
            setDataStatus('ready');
            setTimeout(() => setAlertShow(false), 10000);
        }
    };

    const handleBlobDownload = async (statementId, sequenceId) => {
        setDataStatus('loading')

        try {
            //reset progress indicator
            setProgressStatus(0);

            //create blob and get sas uri
            let statementDownloadUri = null;
            let fileName = null;
            await getStatementDownloadUri(statementId, sequenceId)
                .then(response => {
                    if (response.success) {
                        statementDownloadUri = response.data.statementDownloadUri;
                        fileName = response.data.statementBlobName;
                        //console.log(statementDownloadUri);

                        //update statement display to show download status as downloaded (if it's a statement item, and user does not have certain roles)
                        //match by statementId/sequence: the grid renders a filtered list, so its row index doesn't line up with documents
                        if (sequenceId > 0 && !accountProfile.hasDocConversion && !accountProfile.isAdmin && !accountProfile.hasImpersonate) {
                            setDocuments(prev => prev.map(doc =>
                                doc.statementId === statementId && doc.sequenceNumber === sequenceId
                                    ? { ...doc, statusId: 3, statusString: 'Downloaded' }
                                    : doc
                            ));
                        }

                        //continue to downloadBlob below...
                    }
                    else {
                        throw 'Failed:', response.statusText + ' : ' + response;
                    }
                });

            //download blob
            //console.log('Download Filename: ' + fileName);
            await downloadBlob(statementDownloadUri, fileName)
                .then(response => {
                    if (response.success) {
                        console.log('Success:', response.success);
                        setDataStatus('ready');

                        setAlertMessage('Document was successfully downloaded!');
                        setAlertShow(true);
                        setAlertVariant('success');
                    }
                    else {
                        console.log('Failed:', response.statusText + ' : ' + response);
                        setDataStatus('ready');
                    }
                });
        }
        catch (ex) {
            console.error('Error:', ex);
            setDataErrors(ex.message);
            setDataStatus('error');

            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage('Download failed.');
        }
        finally {
            //set the alert to close after 10 seconds
            setTimeout(() => {
                setAlertShow(false);
            }, 10000);
        }

        return { success: true };
    };

    //get the download uri
    const getStatementDownloadUri = async (statementId, sequenceId) => {
        //console.log('Getting download uri...');

        let apiUrl = '';
        if (sequenceId === 0) {
            apiUrl = 'a_export/getstatementrequestdownloaduri?accountId=' + currentAccount.id + '&statementId=' + statementId;
        } else {
            apiUrl = 'a_export/getstatementdownloaduri?accountId=' + currentAccount.id + '&statementId=' + statementId + '&sequenceId=' + sequenceId;
        }
        //console.log(apiUrl);

        
        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const resultString = await response.text();
        const json = JSON.parse(resultString);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok, ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    }

    //download blob using sas
    const downloadBlob = async (sasTokenUrl, fileName) => {
        console.log('Downloading blob...');

        const blockBlobClient = new BlockBlobClient(sasTokenUrl);

        //note: streaming only works for upload in browser; will need to change to stream from Web Api later to get progress
        //const downloadResponse = await blockBlobClient.download({
        //    blockSize: 4 * 1024 * 1024,
        //    concurrency: 20,
        //    onProgress: ev => console.log('Download Progress: ' + ev)
        //});
        const downloadResponse = await blockBlobClient.download();

        const response = await downloadResponse.blobBody
            .then(blobBody => {
                // Creating new object of file
                const fileURL = window.URL.createObjectURL(blobBody);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = fileName;
                alink.click();

                return { success: true };
            })
            .catch((ex) => {
                return { success: false, statusText: ex.message };
            });

        setDataStatus('ready');
        return response;
    };

    //Generate-and-download a statement export via one of the api/a_export/*ByStatement
    //endpoints. Used by the Excel and CDEX buttons when the row has a DataFileId.
    //For DataFileId == null rows the buttons fall back to handleBlobDownload.
    //format: 'excel' | 'jib' | 'cdex' — selects endpoint + file extension.
    const handleStatementExport = async (statementId, sequenceNumber, format, inputFileName) => {
        setDataStatus('loading');
        try {
            let endpoint = '';
            let extension = '';
            switch (format) {
                case 'excel':
                    endpoint = 'a_export/ExcelByStatement';
                    extension = 'xlsx';
                    break;
                case 'jib':
                    endpoint = 'a_export/JibByStatement';
                    extension = 'xlsx';
                    break;
                case 'cdex':
                    endpoint = 'a_export/CDEXByStatement';
                    extension = 'dat';
                    break;
                default:
                    setDataStatus('ready');
                    return;
            }

            const url = endpoint + '?statementId=' + statementId + '&flagGenerated=true';
            const response = await apiGet(url, getAccessTokenSilently);
            if (!response || !response.ok) {
                throw new Error('Export failed: ' + (response ? response.status : 'no response'));
            }

            const blob = await response.blob();
            const fileURL = window.URL.createObjectURL(blob);
            const base = inputFileName ? inputFileName.replace(/\.[^/.]+$/, '') : 'Statement_' + statementId;
            const fileName = base + '.' + extension;
            const alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = fileName;
            alink.click();
            window.URL.revokeObjectURL(fileURL);

            //flip the row to Downloaded locally; only Available(2)/Downloaded(3) flip, matching the server
            //match by statementId/sequence: the grid renders a filtered list, so its row index doesn't line up with documents
            if (sequenceNumber > 0 && !accountProfile.hasDocConversion && !accountProfile.isAdmin && !accountProfile.hasImpersonate) {
                setDocuments(prev => prev.map(doc =>
                    doc.statementId === statementId && doc.sequenceNumber === sequenceNumber && (doc.statusId === 2 || doc.statusId === 3)
                        ? { ...doc, statusId: 3, statusString: 'Downloaded' }
                        : doc
                ));
            }

            setAlertMessage('Document was successfully downloaded!');
            setAlertShow(true);
            setAlertVariant('success');
            setDataStatus('ready');
        } catch (ex) {
            console.error('Export error:', ex);
            setDataErrors(ex.message);
            setDataStatus('error');
            setAlertShow(true);
            setAlertVariant('danger');
            setAlertMessage('Download failed.');
        } finally {
            setTimeout(() => setAlertShow(false), 10000);
        }
    };

    //*********************************************End - Document Download*******************************************//

    //handle page click
    const handlePageClick = async (currentPage) => {
        console.log('Current Page: ' + currentPage);

        setDataStatus('loading');

        let skipCount = (currentPage === 1 ? 0 : (currentPage - 1) * dataCriteria.takeCount);
        console.log('Skip Count: ' + skipCount);
        setDataCriteria({
            ...dataCriteria,
            skipCount: skipCount
        });

        const currentCriteria = {
            ...dataCriteria,
            skipCount: skipCount
        };

        await getStatements(currentCriteria, sortBy, sortDirection)
            .then(response => {
                if (response.data.data.length === 0) {
                    setDocuments([]);
                    setRowCount(0);
                    setDataStatus('nodata');
                } else {
                    setDocuments(response.data.data);
                    setRowCount(response.data.rowCount);
                    setDataStatus('ready');
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //populate check statements
    const populateCheckStatements = async (skipCount) => {
        //console.log('Getting CheckStatements...');

        const apiUrl = 'accounts/' + currentAccount.id + '/checkstatements?operatorId=' + dataCriteria.operatorId + '&skipCount=' + skipCount + '&takeCount=' + dataCriteria.takeCount + '&companyCode=' + dataCriteria.companyCode + '&fromMonth=' + dataCriteria.fromMonth + '&fromYear=' + dataCriteria.fromYear + '&toMonth=' + dataCriteria.toMonth + '&toYear=' + dataCriteria.toYear + '&statusId=' + dataCriteria.statusId;
        //console.log(apiUrl);
        
        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json }
    };

    const downloadCdex = async (exportType, checkId, index) => {

        const checkStatement = { ...checkStatements[index] };
        const senderId = checkStatement.operatorId;
        const cdexSenderCode = checkStatement.cdexSenderCode;
        console.log('CheckId: ' + checkId + ', SenderId: ' + senderId + ', Cdex Sender Code: ' + cdexSenderCode);
        if ((cdexSenderCode ?? '') == '') {
            setSelectedOperator(checkStatement);
            setDocumentInputModalShow(true);
        }
        else {
            //alert('downloading...');
            await downloadPdf(exportType, checkId, index);
        }       
    }

    //update cdexsendercode
    const updateCdexSenderCode = async (operatorId, cdexSenderCode) => {
        console.log('Saving cdexsendercode...');
        //setDataStatus('loading');

        console.log('OperatorId: ' + operatorId + ', CdexSenderCode: ' + cdexSenderCode);

        var selectedCompany = { id: operatorId, cdexSenderCode: cdexSenderCode };

        await saveCdexSenderCode(selectedCompany)
            .then(response => {
                if (response.success) {
                    setCheckStatements(checkStatements.map((checkStatement, index) => {
                        if (checkStatement.operatorId == selectedCompany.id) {
                            return { ...checkStatement, cdexSenderCode: cdexSenderCode };
                        }
                        else {
                            return checkStatement;
                        }
                    }));
                    console.log('ready');
                    //setDataStatus('ready');
                    setDocumentInputModalShow(false);
                }
                else {
                    //TODO: figure out what to do here
                    console.log('nodata');
                    //setDataStatus('nodata')
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                //do something
            })
    };

    //save cdexsendercode
    const saveCdexSenderCode = async (selectedCompany) => {
        console.log('Saving cdexsendercode...');

        const apiUrl = 'accounts/' + currentAccount.id + '/updatesendingoperator/' + selectedCompany.id;
        const jsonBody = JSON.stringify(selectedCompany);
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);

        return { success: response.ok };
    };

    const downloadPdf = async (exportType, checkId, index) => {
        try {
            setDataStatus('loading');

            //let apiUrl = baseUrl + 'a_export/';
            let apiUrl = 'a_export/';
            let fileName = 'RevenueStatement.';
            switch (exportType) {
                case 'Pdf':
                    apiUrl = apiUrl + 'pdf';
                    fileName = fileName + 'pdf';
                    break;
                case 'Excel':
                    apiUrl = apiUrl + 'excel';
                    fileName = fileName + 'xlsx';
                    break;
                case 'Cdex':
                    apiUrl = apiUrl + 'cdex';
                    fileName = fileName + 'dat';                    
                    break;
                default:
                    break;
            }

            apiUrl = apiUrl + '?checkid=' + checkId + '&flaggenerated=true';
            //console.log(apiUrl);

            await getDocument(checkId, apiUrl).then(response => {
                response.data.blob().then(blob => {
                    // Creating new object of PDF file
                    const fileURL = window.URL.createObjectURL(blob);
                    // Setting various property values
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download = fileName;
                    alink.click();

                    //https://stackoverflow.com/questions/29537299/how-can-i-update-state-item1-in-state-using-setstate
                    let checks = [...checkStatements];
                    let check = { ...checkStatements[index] };
                    check.ownerStatus = true;
                    checks[index] = check;
                    setCheckStatements(checks);

                    setDataStatus('ready');
                })
            });
        } catch (ex) {
            console.log(ex.message);
            setDataStatus('error');
            setDataErrors(ex.message);
        }        
    };

    //getDocument
    const getDocument = async (checkId, apiUrl) => {
        //console.log('Getting User Profile...');

        console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Data: ' + response);

        return { success: response.ok, data: response };
    }


    //Drop edit
    //Operator search
    const applyOperatorFilter = (value) => {

        setDataCriteria(prev => ({
            ...prev,
            operatorName: value,
            operatorNameExact: false
        }));

        setSearchOpTerm(value);

        setFilteredOperators(
            unFilteredOperators.filter((operator) => matchesNameSearch(operator, value))
        );
    }

    //formats as typed like Register.js ($1,234.56), keeping typed decimals; invalid keystrokes are rejected
    const handleCheckAmountChange = (event) => {
        const inputBox = event.target;
        const oldValue = dataCriteria.checkAmount || '';
        let positionIncrement = 0;

        let newValue = inputBox.value.replace('$', '').replaceAll(',', '');

        if (newValue === '.') {
            newValue = '0.';
            positionIncrement = 1;
        } else if (newValue === '-.') {
            newValue = '-0.';
            positionIncrement = 1;
        }

        if (!/^-?\d*\.?\d{0,2}$/.test(newValue)) {
            newValue = oldValue;
            positionIncrement = -1;
        } else if (/\d/.test(newValue)) {
            const [whole, decimals] = newValue.split('.');
            const sign = whole.startsWith('-') ? '-' : '';
            const digits = whole.replace('-', '') || '0';
            newValue = '$' + sign + Number(digits).toLocaleString('en-US') + (decimals !== undefined ? '.' + decimals : '');
        }

        positionIncrement += (newValue.match(/,/g) || []).length - (oldValue.match(/,/g) || []).length;
        positionIncrement += (newValue.match(/\$/g) || []).length - (oldValue.match(/\$/g) || []).length;
        if (oldValue === '') {
            positionIncrement += 1;
        }

        const startPos = inputBox.selectionStart + positionIncrement;
        const endPos = inputBox.selectionEnd + positionIncrement;
        setTimeout(() => {
            inputBox.setSelectionRange(startPos, endPos);
        }, 10);

        setDataCriteria(prev => ({ ...prev, checkAmount: newValue }));
    };

    //picked from the list: exact match; "All" clears
    const selectOperator = (value) => {
        const exact = value !== '';
        setSearchOpTerm(value);
        if (!exact) {
            setFilteredOperators(unFilteredOperators);
        }
        setDataCriteria(prev => ({
            ...prev,
            operatorName: value,
            operatorNameExact: exact
        }));
        runSearch({ operatorName: value, operatorNameExact: exact });
    };

    //Drop edit
    //Owner search
    const applyOwnerFilter = (value) => {

        setDataCriteria(prev => ({
            ...prev,
            ownerName: value,
            ownerNameExact: false
        }));

        setSearchOwnerTerm(value);
        setFilteredOwners(
            unFilteredOwners.filter((owner) => matchesNameSearch(owner, value))
        );
    };

    //picked from the list: exact match; "All" clears
    const selectOwner = (value) => {
        const exact = value !== '';
        setSearchOwnerTerm(value);
        if (!exact) {
            setFilteredOwners(unFilteredOwners);
        }
        setDataCriteria(prev => ({
            ...prev,
            ownerName: value,
            ownerNameExact: exact
        }));
        runSearch({ ownerName: value, ownerNameExact: exact });
    };

    //Drop edit
    //Category search
    const applyCatFilter = (value) => {
        const fieldName = "statementCategoryId";

        setDataCriteria({       
            ...dataCriteria,    //id is set when user clicks an item
            [fieldName]: 0
        });

        setSearchCatTerm(value);
        setFilteredCategories(
            statementCategories.filter((category) => {
                const codeLower = category.code.toLowerCase();
                const nameLower = category.name.toLowerCase();
                const combinedLower = `${ category.code } - ${ category.name }`.toLowerCase();
                const searchLower = value.toLowerCase();

                return (
                    codeLower.startsWith(searchLower) ||
                    nameLower.startsWith(searchLower) ||
                    combinedLower.startsWith(searchLower)
                );
            })
        );
    };

    const handleLiveCategoryChange = (e) => {
        e.preventDefault();
        applyCatFilter(e.target.value);
    };

    function getDocConvNetworkTypeName(docConvType) {
        switch (docConvType) {
            case 1:
                return 'IMTS';
            case 2:
                return ''
            default:
                return '';
        }
    }

    function getDocConvOutputTypeName(docConvType) {
        switch (docConvType) {
            case 1:
                return 'OGSYS_PCX';
            case 2:
                return 'CDEX'
            case 3:
                return 'EL_XLS'
            default:
                return '';
        }
    }


    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const showPageLoading = () => {
        return (
            <tr>
                <td colSpan={11} className="text-center">
                    <Spinner
                        animation="border"
                        style={{
                            color: COLORS.gold
                        }}
                    />
                </td>
            </tr>
        )
    }

    //render page loading
    const showDataLoading = () => {
        return (
            <div className="d-flex justify-content-center align-items-center h-100 w-100">
                <Spinner
                    animation="border"
                    style={{ width: '5rem', height: '5rem', borderWidth: '0.5rem', color: COLORS.gold }}
                />
            </div>
        );
    }

    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was a data load error: {dataErrors}
            </Row>
        );
    }

    ////render loading
    //const showLoading_BAK = () => {
    //    return (
    //        <div>
    //            <img src={spinnerIcon} alt="loading..." />
    //        </div>
    //    );
    //}

    //render table container
    const showTableContainer = () => {
        return (
            <Card className="mb-3 shadow-sm">
                <Card.Header style={{ ...header, padding: '6px 16px' }}>
                    {showInputCriteria()}
                </Card.Header>
                <Card.Body style={{ height: (screenHeight - screenHeightAdjust).toString() + 'px', overflow: "auto", paddingTop: 0 }}>
                    {(() => {
                        switch (dataStatus) {
                            case 'loading':
                                return showDataLoading()
                            case 'uploading':
                                return showBlobUploading()
                            case 'ready':
                                return showData()
                            case 'nodata':
                                return showData()
                            case 'error':
                                return showDataError()
                            default:
                                return showData()
                        }
                    })()}
                </Card.Body>
                <Card.Footer style={{ ...footer, padding: '4px 16px 10px 16px' }}>
                    <Container fluid style={{ height: '20px' }} >
                    {(() => {
                        if (dataStatus === 'ready') {
                            return <Row className="g-0 h-100">
                                        <Col className="d-flex justify-content-end align-items-center dc-pagination-wrap">
                                            <style>{`
                                                .dc-pagination-wrap .pagination {
                                                    margin: 0;
                                                    gap: 3px;
                                                    align-items: center;
                                                }
                                                .dc-pagination-wrap .page-item .page-link {
                                                    background-color: rgba(255, 255, 255, 0.08);
                                                    border: 1px solid rgba(200, 182, 104, 0.7);
                                                    color: #d5c478;
                                                    font-size: 0.7rem;
                                                    font-weight: 500;
                                                    line-height: 1;
                                                    padding: 3px 8px;
                                                    min-width: 24px;
                                                    height: 22px;
                                                    display: inline-flex;
                                                    align-items: center;
                                                    justify-content: center;
                                                    border-radius: 4px;
                                                    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
                                                    cursor: pointer;
                                                    box-shadow: none;
                                                }
                                                .dc-pagination-wrap .page-item .page-link:hover {
                                                    background-color: rgba(200, 182, 104, 0.22);
                                                    border-color: #d5c478;
                                                    color: #f1e0a0;
                                                }
                                                .dc-pagination-wrap .page-item .page-link:focus {
                                                    outline: none;
                                                    box-shadow: 0 0 0 2px rgba(200, 182, 104, 0.35);
                                                }
                                                .dc-pagination-wrap .page-item.active .page-link {
                                                    background-color: #c8b668;
                                                    border-color: #c8b668;
                                                    color: #1a1a1a;
                                                    font-weight: 600;
                                                }
                                                .dc-pagination-wrap .page-item.disabled .page-link {
                                                    background-color: transparent;
                                                    border-color: rgba(200, 182, 104, 0.15);
                                                    color: rgba(200, 182, 104, 0.35);
                                                    cursor: not-allowed;
                                                }
                                                .dc-pagination-wrap .page-item:first-child .page-link,
                                                .dc-pagination-wrap .page-item:last-child .page-link {
                                                    font-size: 1rem;
                                                    font-weight: 700;
                                                    line-height: 0.8;
                                                    padding: 0 6px;
                                                    min-width: 26px;
                                                }
                                            `}</style>
                                            <PaginationComponent
                                                itemsCount={rowCount}
                                                itemsPerPage={dataCriteria.takeCount}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                                pageClickHandler={handlePageClick}
                                                alwaysShown={true}
                                                itemStyle={{}}
                                                activeItemStyle={{}}
                                            />
                                        </Col>
                                    </Row>                                    
                        }
                    })()}       
                    </Container>
                </Card.Footer>
            </Card>
        );
    }

    //render input criteria
    const showInputCriteria = () => {
        return (
            <Form onSubmit={submitForm}>
                {/*DEFAULT FILTERS */}
                <Row className="g-1 align-items-end">

                    {/*Doc Id*/}
                    <Col xs={6} md={1}>
                        <Form.Group controlId="statementId" className="h-100 d-flex flex-column justify-content-end">
                            <Form.Label style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0 }}>Doc Id</Form.Label>
                            <Form.Control
                                style={{ ...inputSm, fontSize: '0.65rem', padding: '2px 6px', height: '22px', minHeight: '22px', lineHeight: 1, boxSizing: 'border-box' }}
                                size="sm"
                                name="statementIdString"
                                disabled={dataStatus === "loading"}
                                onChange={handleChange}
                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            />
                        </Form.Group>
                    </Col>

                    {/*Operator Name*/}
                    <Col xs={6} md={1}>
                        <Form.Group controlId="operatorName" className="h-100 d-flex flex-column justify-content-end">
                            <Form.Label style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0 }}>Operator</Form.Label>
                            <NameFilterDropdown
                                id="dd-operator"
                                label="Operator"
                                term={searchOpTerm}
                                names={filteredOperators}
                                totalCount={unFilteredOperators.filter(n => typeof n === 'string' && n.trim().length > 0).length}
                                selectedName={dataCriteria.operatorNameExact ? dataCriteria.operatorName : (dataCriteria.operatorName === '' ? '' : null)}
                                disabled={dataStatus === "loading"}
                                toggleStyle={{ ...dropDownToggle, fontSize: '0.65rem', padding: '2px 17px 2px 6px', height: '22px', minHeight: '22px', lineHeight: 1, boxSizing: 'border-box' }}
                                onTermChange={applyOperatorFilter}
                                onSelect={selectOperator}
                            />
                        </Form.Group>
                    </Col>

                    {/*Search button*/}
                    <Col xs={12} md={2} className="d-flex align-items-end gap-1">
                        {dataStatus === 'loading' ? (
                            <Button
                                //style={{ ...searchBtn }}
                                style={{ ...btnGold, marginRight: 3, height: '22px', padding: '0 8px', fontSize: '0.75rem' }}
                                size="sm"
                                disabled
                            >
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                        ) : (
                            <Button
                                style={
                                    hoveredBtn && hoveredBtn?.type === 'search'
                                        ? { ...btnGold, ...btnGoldHover, marginRight: 3, transition: "all .15s ease", height: '22px', padding: '0 8px', fontSize: '0.75rem' }
                                        : { ...btnGold, marginRight: 3, height: '22px', padding: '0 8px', fontSize: '0.75rem' }
                                }
                                onMouseEnter={() => setHoveredBtn({ type: 'search' })}
                                onMouseLeave={() => setHoveredBtn(null)}
                                type="submit"
                                size="sm"
                                disabled={pageStatus === 'loading'}
                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            >
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </Button>
                        )}
                            {/*Advancer Filter Button*/}
                            <Button
                                variant="link"
                                size="sm"
                                style={{ ...showAdvancedBtn, fontSize: '0.75rem' }}
                                onClick={() =>
                                    setShowAdvanced(prev => {
                                        const next = !prev;
                                        setScreenHeightAdjust(next ? 362 : 302);
                                        return next;
                                    })
                                }
                                onMouseEnter={e => Object.assign(e.target.style, addUnderline)}
                                onMouseLeave={e => Object.assign(e.target.style, goldLinkBase)}
                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            >
                            {showAdvanced ? "Hide" : "Show"} advanced<FontAwesomeIcon icon={faFilter}/>
                            </Button>
                    </Col>

                    {/*Upload Button*/}
                    <Col xs={12} md="auto" className="ms-md-auto">
                        <Stack
                            direction="horizontal"
                            gap={2}
                            className="justify-content-md-end flex-wrap"
                        >
                            <Button
                                style={{ ...uploadBtn, padding: '0 20px', fontSize: '0.95rem', height: '34px', fontWeight: 600 }}
                                size="sm"
                                onClick={() => {
                                    console.log("docConversionNetworkType: " + docConversionNetworkType)
                                    if (docConversionNetworkType !== 0) {
                                        // auto-fill the delivery email with the logged-in user's email
                                        setNewItemCriteria(prev => ({ ...prev, deliveryEmail: prev.deliveryEmail || accountProfile?.email || '' }));
                                        setDocumentInputModalShow(true);
                                    } else {
                                        setNoDocConversionModalShow(true);
                                    }
                                }}
                                disabled={accountProfile.hasDocConversion || dataStatus === 'loading' || dataStatus === 'uploading'}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            >
                                Upload Documents
                            </Button>

                        </Stack>
                    </Col>
                </Row>

                {/*ADVANCED FILTERS*/}
                <Collapse in={showAdvanced}>
                    <div>
                        <hr style={{ margin: "6px 0" }} />
                        <Row className="g-1 align-items-end">

                            {/*Check #*/}
                            <Col xs={6} md={1}>
                                <Form.Group controlId="checkNumber" className="h-100 d-flex flex-column justify-content-end">
                                    <Form.Label style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0 }}>Check #</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        name="checkNumber"
                                        disabled={dataStatus === "loading"}
                                        onChange={handleChange}
                                        style={{ ...inputSm, fontSize: '0.65rem', padding: '2px 6px', height: '22px', minHeight: '22px', lineHeight: 1, boxSizing: 'border-box' }}
                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    />
                                </Form.Group>
                            </Col>

                            {/*Check Date*/}
                            <Col xs={6} md={1}>
                                <Form.Group controlId="checkDate" className="h-100 d-flex flex-column justify-content-end">
                                    <Form.Label style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0 }}>Check Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        name="checkDate"
                                        value={dataCriteria.checkDate}
                                        disabled={dataStatus === "loading"}
                                        onChange={handleChange}
                                        style={{ ...inputSm, fontSize: '0.65rem', padding: '2px 6px', height: '22px', minHeight: '22px', lineHeight: 1, boxSizing: 'border-box' }}
                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    />
                                </Form.Group>
                            </Col>

                            {/*Received Date*/}
                            <Col xs={12} md="auto">
                                <Form.Label style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0 }}>Received</Form.Label>
                                <div
                                    title={isReceivedRangeInverted(dataCriteria) ? 'From is after To' : undefined}
                                    style={{
                                        ...receivedRangeStyles.group,
                                        ...(isReceivedRangeInverted(dataCriteria) ? receivedRangeStyles.groupInvalid : {}),
                                        ...(dataStatus === "loading" ? receivedRangeStyles.groupDisabled : {})
                                    }}
                                    onFocus={e => Object.assign(e.currentTarget.style, receivedRangeStyles.groupFocus)}
                                    onBlur={e => Object.assign(e.currentTarget.style, { boxShadow: 'none', borderColor: isReceivedRangeInverted(dataCriteria) ? receivedRangeStyles.groupInvalid.borderColor : receivedRangeStyles.group.borderColor })}
                                >
                                    <span style={receivedRangeStyles.tag}>From</span>
                                    <Form.Select
                                        size="sm"
                                        name="fromMonth"
                                        aria-label="Received from month"
                                        disabled={dataStatus === "loading"}
                                        value={dataCriteria.fromMonth}
                                        onChange={handleChange}
                                        style={receivedRangeStyles.select}
                                    >
                                        {months.map((m, i) => (
                                            <option key={m} value={i + 1}>
                                                {m.slice(0, 3)}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Select
                                        size="sm"
                                        name="fromYear"
                                        aria-label="Received from year"
                                        disabled={dataStatus === "loading"}
                                        value={dataCriteria.fromYear}
                                        onChange={handleChange}
                                        style={receivedRangeStyles.select}
                                    >
                                        {years.map((y) => (
                                            <option key={y}>{y}</option>
                                        ))}
                                    </Form.Select>

                                    <span style={receivedRangeStyles.divider} />

                                    <span style={receivedRangeStyles.tag}>To</span>
                                    <Form.Select
                                        size="sm"
                                        name="toMonth"
                                        aria-label="Received to month"
                                        disabled={dataStatus === "loading"}
                                        value={dataCriteria.toMonth}
                                        onChange={handleChange}
                                        style={receivedRangeStyles.select}
                                    >
                                        {months.map((m, i) => (
                                            <option key={m} value={i + 1}>
                                                {m.slice(0, 3)}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Select
                                        size="sm"
                                        name="toYear"
                                        aria-label="Received to year"
                                        disabled={dataStatus === "loading"}
                                        value={dataCriteria.toYear}
                                        onChange={handleChange}
                                        style={receivedRangeStyles.select}
                                    >
                                        {years.map((y) => (
                                            <option key={y}>{y}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </Col>

                            {/*Owner Name*/}
                            <Col xs={6} md={1}>
                                <Form.Group controlId="ownerName" className="h-100 d-flex flex-column justify-content-end">
                                    <Form.Label style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0 }}>Owner Name</Form.Label>
                                    <NameFilterDropdown
                                        id="dd-owner"
                                        label="Owner"
                                        term={searchOwnerTerm}
                                        names={filteredOwners}
                                        totalCount={unFilteredOwners.filter(n => typeof n === 'string' && n.trim().length > 0).length}
                                        selectedName={dataCriteria.ownerNameExact ? dataCriteria.ownerName : (dataCriteria.ownerName === '' ? '' : null)}
                                        disabled={dataStatus === "loading"}
                                        toggleStyle={{ ...dropDownToggle, fontSize: '0.65rem', padding: '2px 17px 2px 6px', height: '22px', minHeight: '22px', lineHeight: 1, boxSizing: 'border-box' }}
                                        onTermChange={applyOwnerFilter}
                                        onSelect={selectOwner}
                                    />
                                </Form.Group>
                            </Col>

                            {/*Owner Number*/}
                            <Col xs={6} md={1}>
                                <Form.Group controlId="ownerNumber" className="h-100 d-flex flex-column justify-content-end">
                                    <Form.Label style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0 }}>Owner Number</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        name="ownerNumber"
                                        disabled={dataStatus === "loading"}
                                        onChange={handleChange}
                                        style={{ ...inputSm, fontSize: '0.65rem', padding: '2px 6px', height: '22px', minHeight: '22px', lineHeight: 1, boxSizing: 'border-box' }}
                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    />
                                </Form.Group>
                            </Col>

                            {/*Check / Invoice Amount*/}
                            <Col xs={6} md={1}>
                                <Form.Group controlId="checkAmount" className="h-100 d-flex flex-column justify-content-end">
                                    <Form.Label title="Check / Invoice Amount" style={{ ...formLabel, fontSize: '0.8rem', lineHeight: '16px', height: '16px', display: 'block', margin: 0, whiteSpace: 'nowrap' }}>Chk/Inv Amt</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        name="checkAmount"
                                        inputMode="decimal"
                                        autoComplete="off"
                                        placeholder="$0.00"
                                        maxLength={15}
                                        value={dataCriteria.checkAmount}
                                        disabled={dataStatus === "loading"}
                                        onChange={handleCheckAmountChange}
                                        style={{ ...inputSm, fontSize: '0.65rem', padding: '2px 6px', height: '22px', minHeight: '22px', lineHeight: 1, boxSizing: 'border-box' }}
                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    />
                                </Form.Group>
                            </Col>

                            {/*Reset Filters*/}
                            <Col xs={6} md={1}>
                                <Button
                                    style={{ ...resetFiltersBtn, height: '22px', padding: '0 12px', fontSize: '0.75rem' }}
                                    type="reset"
                                    onClick={handleResetFilters}
                                    size="sm"
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Collapse>
            </Form>
        );
    }

    //render datafiles
    const showData = () => {
        const renderTooltip = props => (
            <Tooltip id="add-cat-tip" {...props}>
                Add new category / organization
            </Tooltip>
        )

        const nonCompleteDocs = documents.filter(doc => (doc.sequenceNumber === 0 && (doc.statusId === 1 || doc.statusId === 5 || doc.statusId === 4)) || (doc.sequenceNumber !== 0)) //filter out rows that say status is "complete"

        //Conditional button text: Now hard coded "Data"
        //const getXlsLabelForDoc = (doc) => {
        //    if (doc?.statementTypeString === "JIB") {
        //        return "XLS";
        //    }
        //    return xlsButtonLabel; 
        //};

        return (
            <Container fluid style={{ padding: 0 }} >
                {/* Instant CSS-only tooltip (same style as the XLS button tooltip on the Admin Dashboard).
                    Wrap a trigger in <span className="dc-inline-tip">{trigger}<span className="dc-inline-tip-text">label</span></span>. */}
                <style>{`
                    .dc-inline-tip { position: relative; display: inline-block; }
                    .dc-inline-tip > .dc-inline-tip-text {
                        position: absolute;
                        right: calc(100% + 8px);
                        top: 50%;
                        transform: translateY(-50%);
                        background: #1f2937;
                        color: #f9fafb;
                        padding: 4px 8px;
                        border-radius: 4px;
                        font-size: .75rem;
                        line-height: 1.2;
                        white-space: nowrap;
                        pointer-events: none;
                        opacity: 0;
                        visibility: hidden;
                        z-index: 5;
                    }
                    .dc-inline-tip:hover > .dc-inline-tip-text {
                        opacity: 1;
                        visibility: visible;
                    }
                    .dc-inline-tip-right { cursor: default; }
                    .dc-inline-tip-right > .dc-inline-tip-text {
                        right: auto;
                        left: calc(100% + 8px);
                        z-index: 20;
                        padding: 6px 10px;
                        background: #6b7280;
                        color: #ffffff;
                        border-radius: 5px;
                        box-shadow: 0 2px 6px rgba(0, 0, 0, .12);
                    }
                    .dc-inline-tip-row { display: block; }
                    .dc-inline-tip-row + .dc-inline-tip-row { margin-top: 3px; }
                    .dc-inline-tip-key {
                        display: inline-block;
                        min-width: 88px;
                        color: #f3f4f6;
                        font-weight: 400;
                    }
                `}</style>
                <Row>
                    <div
                        style={{
                            maxoverflow: 'auto'
                        }}
                    >
                        <table className="table table-sm table-striped" aria-labelledby="tabelLabel" style={{ fontSize: '.72rem', borderCollapse: 'separate', borderSpacing: 0 }} >
                            <thead>
                                <tr>
                                    {/*--------------------------------------------COLUMN TITLES--------------------------------------------*/}
                                    {/*DOC ID*/}
                                    <th style={{ ...stickyThStyle }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'StatementId' ? 'black' : 'black')
                                            }}
                                            onClick={() => handleSortChange('StatementId')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            Doc Id{sortBy === 'StatementId' ?
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '0px',
                                                        paddingBottom: '2px',
                                                        paddingLeft: '5px',
                                                        width: '8px',
                                                        height: '12px'
                                                    }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*STMT TYPE*/}
                                    <th style={{ ...stickyThStyle, textAlign: 'left', padding: '0px', fontSize: '13.5px', fontWeight: '700', paddingBottom: '2px' }}>
                                        <Form.Group controlId="statementTypeId">
                                            <Form.Select
                                                name="statementTypeId"
                                                onChange={handleChange}
                                                disabled={dataStatus === "loading"}
                                                className="border-0"
                                                style={{
                                                    ...columnTitle,
                                                    fontSize: "0.62rem",
                                                    textAlign: "left",
                                                    paddingRight: '2.0rem',
                                                    paddingLeft: '0.5rem',
                                                    paddingBottom: 3
                                                }}
                                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            >
                                                <option hidden>Stmt Type</option>
                                                {statementTypes.map((t) => (
                                                    <option key={t.id} value={t.id}>
                                                        {t.type}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            {dataCriteria.statementTypeId !== 0 && dataCriteria.statementTypeId !== '' && (
                                                <span style={filterActiveIndicator} title="Filter active" />
                                            )}
                                        </Form.Group>
                                    </th>

                                    {/*OPERATOR NAME*/}
                                    <th style={{ ...stickyThStyle, width: '120px', maxWidth: '120px' }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'OperatorName' ? 'black' : 'black')
                                            }}
                                            onClick={() => handleSortChange('OperatorName')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            Operator Name{sortBy === 'OperatorName' ?
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '0px',
                                                        paddingBottom: '2px',
                                                        paddingLeft: '5px',
                                                        width: '8px',
                                                        height: '12px'
                                                    }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*OWNER ID*/}
                                    <th style={{ ...stickyThStyle }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'OwnerId' ? 'black' : 'black')
                                            }}
                                            onClick={() => handleSortChange('OwnerId')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            Owner #{sortBy === 'OwnerId' ?
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '0px',
                                                        paddingBottom: '2px',
                                                        paddingLeft: '5px',
                                                        width: '8px',
                                                        height: '12px'
                                                    }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*OWNER NAME*/}
                                    <th style={{ ...stickyThStyle }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'OwnerName' ? 'black' : 'black')
                                            }}
                                            onClick={() => handleSortChange('OwnerName')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            Owner Name{sortBy === 'OwnerName' ?
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '0px',
                                                        paddingBottom: '2px',
                                                        paddingLeft: '5px',
                                                        width: '8px',
                                                        height: '12px'
                                                    }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*CATEGORY / ORG*/}
                                    <th style={{ ...stickyThStyle, textAlign: 'left' }}>
                                        <Form.Group controlId="statementCategoryId">
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    id="dd-category"
                                                    bsPrefix="form-select"
                                                    disabled={dataStatus === "loading"}
                                                    variant="light"
                                                    size="sm"
                                                    style={{
                                                        ...columnTitle,
                                                        fontSize: "0.62rem",
                                                        backgroundColor: "white",
                                                        border: "none",
                                                        width: "6.2rem",
                                                        display: 'inline-block',
                                                        paddingRight: '1.75rem',
                                                        paddingBottom: 4,
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                >
                                                    {searchCatTerm || "Cat/Org"}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu style={{ ...dropDownMenu }}>
                                                    <div className="d-flex align-items-center px-2 mb-2">
                                                        <FormControl
                                                            autoFocus
                                                            placeholder="Search..."
                                                            aria-label="Search category"
                                                            disabled={dataStatus === "loading"}
                                                            value={searchCatTerm}
                                                            onChange={handleLiveCategoryChange}
                                                            style={{ fontSize: '13.5px', fontWeight: '700' }}
                                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                        />
                                                        <OverlayTrigger placement="right" overlay={renderTooltip} transition={false} container={document.body}>
                                                            <Button
                                                                className="p-2"
                                                                disabled={accountProfile.hasDocConversion}
                                                                style={{ lineHeight: 1, ...btnGold, ...btnGoldHover, marginLeft: 5 }}
                                                                onClick={() => setCategoryAddModalShow(true)}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                    <Dropdown.Item
                                                        key="all"
                                                        onClick={() => {
                                                            setSearchCatTerm("");
                                                            handleChange({
                                                                preventDefault: () => { },
                                                                target: { name: "statementCategoryId", value: 0 }
                                                            });
                                                        }}
                                                    >
                                                        All
                                                    </Dropdown.Item>
                                                    {filteredCategories.length ? (
                                                        filteredCategories
                                                            .filter(cat => !(cat.code === '' & cat.name === ''))    //skip empty values
                                                            .map((cat) => (
                                                            <Dropdown.Item
                                                                key={cat.id}
                                                                onClick={() => {
                                                                    setSearchCatTerm(`${cat.code} - ${cat.name}`);
                                                                    handleChange({
                                                                        preventDefault: () => { },
                                                                        target: { name: "statementCategoryId", value: cat.id }
                                                                    });
                                                                }}
                                                            >
                                                                {cat.code} {cat.name && ` - ${cat.name}`}
                                                            </Dropdown.Item>
                                                        ))
                                                    ) : (
                                                        <div className="text-center p-2">No results found</div>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </th>

                                    {/*CHECK #*/}
                                    <th style={{ ...stickyThStyle }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'CheckNumber' ? 'black' : 'black')
                                            }}
                                            onClick={() => handleSortChange('CheckNumber')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            Chk/Inv #{sortBy === 'CheckNumber' ?
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '0px',
                                                        paddingBottom: '2px',
                                                        paddingLeft: '5px',
                                                        width: '8px',
                                                        height: '12px'
                                                    }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*CHECK DATE*/}
                                    <th style={{ ...stickyThStyle }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'CheckDate' ? 'black' : 'black')
                                            }}
                                            onClick={() => handleSortChange('CheckDate')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                        >
                                            Chk/Inc Date{sortBy === 'CheckDate' ?
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{ cursor: 'pointer', padding: '0px', paddingBottom: '2px', paddingLeft: '5px', width: '8px', height: '12px' }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*CHECK AMOUNT*/}
                                    <th style={{ ...stickyThStyle }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'CheckAmount' ? 'black' : 'black') 
                                            }} 
                                            onClick={() => handleSortChange('CheckAmount')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                         >
                                            Chk/Inv Amt{sortBy === 'CheckAmount' ? 
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '0px',
                                                        paddingBottom: '2px',
                                                        paddingLeft: '5px',
                                                        width: '8px',
                                                        height: '12px'
                                                    }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*STATUS DATE*/}
                                    <th style={{ ...stickyThStyle }}>
                                        <Button
                                            variant="link"
                                            style={{
                                                ...columnSortLink,
                                                fontSize: "0.62rem",
                                                color: (sortBy === 'StatusDate' ? 'black' : 'black')
                                            }}
                                            onClick={() => handleSortChange('StatusDate')}
                                            onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                            onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                         >
                                            Status Date{sortBy === 'StatusDate' ?
                                                <FontAwesomeIcon
                                                    icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '0px',
                                                        paddingBottom: '2px',
                                                        paddingLeft: '5px',
                                                        width: '8px',
                                                        height: '12px'
                                                    }}
                                                /> : ''}
                                        </Button>
                                    </th>

                                    {/*STATUS*/}
                                    <th style={{ ...stickyThStyle, textAlign: 'left', padding: '0px', fontSize: '13.5px', fontWeight: '700', paddingBottom: '2px' }}>
                                        <Form.Group controlId="statusId">
                                            <Form.Select
                                                name="statusId"
                                                onChange={handleChange}
                                                disabled={dataStatus === "loading"}
                                                className="border-0"
                                                style={{
                                                    ...columnTitle,
                                                    fontSize: "0.62rem",
                                                    textAlign: 'left',
                                                    width: "auto",
                                                    paddingRight: "0.0rem",
                                                    paddingBottom: 3
                                                }}
                                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                            >
                                                <option hidden>Status</option>
                                                {statusItems.map((s) => {
                                                    //Non-admins see "Mapping" instead of "Mapping Needed" — the
                                                    //underlying id (7) and filter behavior are unchanged.
                                                    const label = (s.id === 7 && !accountProfile.hasImpersonate) ? 'Mapping' : s.status;
                                                    return (
                                                        <option key={s.id} value={s.id}>
                                                            {label}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            {dataCriteria.statusId !== 0 && dataCriteria.statusId !== '' && (
                                                <span style={filterActiveIndicator} title="Filter active" />
                                            )}
                                        </Form.Group>
                                    </th>

                                    {/*GROUP DOWNLOAD (checkbox column)*/}
                                    <th style={{ ...stickyThStyle, textAlign: 'center', padding: '0 4px', paddingBottom: '2px', verticalAlign: 'bottom' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1 }}>
                                            <span style={{ fontSize: '0.55rem', fontWeight: 700, textTransform: 'uppercase', color: '#333', whiteSpace: 'nowrap', marginBottom: 2 }}>Group Download</span>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 4 }}>
                                                {docConversionNetworkType === 1 ? (
                                                    <span style={{ fontSize: '0.62rem', fontWeight: 600, color: '#333', padding: '1px 4px' }}>CDEX</span>
                                                ) : docConversionOutputType === 2 ? (
                                                    <Form.Select
                                                        size="sm"
                                                        value={groupDownloadFormat}
                                                        onChange={e => setGroupDownloadFormat(e.target.value)}
                                                        disabled={dataStatus === 'loading' || dataStatus === 'uploading'}
                                                        style={{ fontSize: '0.62rem', padding: '1px 18px 1px 4px', height: 20, lineHeight: 1, width: 'auto', minWidth: '3.3rem' }}
                                                    >
                                                        <option value="excel">XLS</option>
                                                        <option value="cdex">CDEX</option>
                                                    </Form.Select>
                                                ) : (
                                                    <span style={{ fontSize: '0.62rem', fontWeight: 600, color: '#333', padding: '1px 4px' }}>XLS</span>
                                                )}
                                                <Button
                                                    size="sm"
                                                    title={`click to download ${selectedDownloads.size} files`}
                                                    aria-label="Download selected as ZIP"
                                                    disabled={selectedDownloads.size === 0 || dataStatus === 'loading' || dataStatus === 'uploading'}
                                                    onClick={handleDownloadSelected}
                                                    style={{ backgroundColor: 'white', color: '#333', border: '1px solid #999', padding: '1px 6px', height: 20, fontSize: '0.62rem', lineHeight: 1, fontWeight: 600, whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 3 }}
                                                >
                                                    <FontAwesomeIcon icon={faArrowDown} style={{ ...faIconStyle(faArrowDown), width: 9, height: 9 }} />
                                                    ({selectedDownloads.size})
                                                </Button>
                                            </div>
                                        </div>
                                    </th>

                                    <th style={{ ...stickyThStyle }}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nonCompleteDocs.length ? (
                                    nonCompleteDocs.map((document, index) => (
                                        <tr
                                            key={document.id}
                                            style={{
                                                fontSize: ".8rem",
                                                fontWeight: "500",
                                            }}
                                            onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                            onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                        >
                                            {/*--------------------------------------------COLUMN VALUES--------------------------------------------*/}
                                            <td>
                                                <span className="dc-inline-tip dc-inline-tip-right">
                                                    {document.statementIdString}
                                                    <span className="dc-inline-tip-text">
                                                        <span className="dc-inline-tip-row"><span className="dc-inline-tip-key">Delivery email</span>{document.deliveryEmail || '(none)'}</span>
                                                        <span className="dc-inline-tip-row"><span className="dc-inline-tip-key">Loaded</span>{document.receivedDateString || '(unknown)'}</span>
                                                    </span>
                                                </span>
                                            </td>
                                            <td>{document.statementTypeString}</td>
                                            <td
                                                style={{
                                                    fontSize: ".7rem",
                                                    fontWeight: "bold",
                                                    maxWidth: '120px',
                                                    whiteSpace: 'normal',
                                                    wordBreak: 'break-word'
                                                }}
                                                title={document.operatorName}
                                            >
                                                {document.operatorName}
                                            </td>
                                            <td>{document.ownerNumber}</td>
                                            <td>{document.ownerName}</td>

                                            {/*CATEGORY*/}
                                            <td>
                                                {(() => {
                                                    if (categoryEditItem === document.statementIdString) {
                                                        return <Form.Select
                                                                    name="statementCategoryId" 
                                                                    size="sm" value={document.statementCategoryId} 
                                                                    aria-label="Org (optional)" 
                                                                    onChange={(e) => handleItemCategoryChange(e, document.statementId, document.sequenceNumber)} 
                                                                    style={{ width: '100px' }} 
                                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })} 
                                                                >
                                                            {statementCategories.map((category, i) => (
                                                                <option key={category.id} value={category.id}>{category.code} {(category.name === '' ? '' : '-')} {category.name}</option>
                                                            ))}
                                                        </Form.Select>
                                                    }
                                                    else if (accountProfile.hasDocConversion) {
                                                        return (
                                                            <span
                                                                style={{
                                                                    textAlign: 'left',
                                                                    padding: '0px',
                                                                    fontSize: '13.5px',
                                                                    fontWeight: '700',
                                                                    color: 'black',
                                                                    fontStyle: 'normal'
                                                                }}
                                                            >
                                                                {(document.statementCategoryCode === '' ? '' : document.statementCategoryCode)}
                                                                {(document.statementCategoryName === '' ? '' : '-')} {document.statementCategoryName}
                                                            </span>);
                                                    }
                                                    else {
                                                        return <Button variant="link"
                                                                    style={{
                                                                        textAlign: 'left',
                                                                        padding: '0px',
                                                                        fontSize: '0.65rem',
                                                                        fontWeight: '600',
                                                                        color: 'black',
                                                                        textDecoration: (document.statementCategoryCode === '' ? 'none' : 'underline'),
                                                                        fontStyle: (document.statementCategoryCode === '' ? 'italic' : 'normal')
                                                                    }}
                                                                    onClick={() => setCategoryEditItem(document.statementIdString)}
                                                                >
                                                                    {(document.statementCategoryCode === '' ? 
                                                                        <> 
                                                                            <FontAwesomeIcon
                                                                                icon={faPlus}
                                                                                style={{
                                                                                    ...goldFaPlus(faPlus),
                                                                                    width: 10,
                                                                                    height: 10
                                                                                }}
                                                                            />
                                                                            <span 
                                                                                style={{ marginLeft: 5, textDecoration: "none" }} 
                                                                                onMouseEnter={e => Object.assign(e.currentTarget.style, addUnderline)} 
                                                                                onMouseLeave={e => Object.assign(e.target.style, removeUnderline)}
                                                                            >
                                                                                Add
                                                                            </span> 
                                                                        </>
                                                                    : document.statementCategoryCode)} {(document.statementCategoryName === '' ? '' : '-')} {document.statementCategoryName}
                                                                </Button>
                                                    }
                                                })()}
                                            </td>
                                            <td>{document.checkNumber}</td>
                                            <td>{document.checkDateString}</td>
                                            <td>{document.checkAmountString}</td>
                                            <td>{document.statusDateString}</td>
                                            {/*STATUS*/}
                                            <td
                                                style={{
                                                    color: "black",
                                                    fontSize: "10px"
                                                }}
                                            >
                                                {/* Mapping Needed (statusId === 7) — the pill itself becomes
                                                    a clickable button that opens the mapping popup. Plain
                                                    <button> element (not react-bootstrap Button) so we don't
                                                    inherit Bootstrap's padding/line-height that would make
                                                    the pill bigger than the static labels on other rows. */}
                                                {document.statusId === 7 && (accountProfile.hasImpersonate || document.senderCodeMappingAvailable) ? (
                                                    /* Clickable "Mapping Needed" button that opens the popup.
                                                       Admins (hasImpersonate) always get it. Non-admin CDEX
                                                       clients get it too when senderCodeMappingAvailable is set
                                                       by the API — i.e. only the 2-digit sender code is left and
                                                       no account/CDEX-code mapping is outstanding. If accounts are
                                                       still required the flag is false and the row falls through
                                                       to the dead "Mapping" label below. */
                                                    <button
                                                        type="button"
                                                        title="Click to enter mappings"
                                                        onClick={() => handleOpenMappingNeeded(document.statementId, document.statementIdString)}
                                                        onMouseEnter={() => setHoveredBtn({ index, type: 'mappingNeeded' })}
                                                        onMouseLeave={() => setHoveredBtn(null)}
                                                        style={
                                                            hoveredBtn?.index === index && hoveredBtn?.type === 'mappingNeeded'
                                                                ? {
                                                                    ...statusLabel,
                                                                    backgroundColor: statusColors[document.statusString] || "inherit",
                                                                    color: 'black',
                                                                    fontSize: '10px',
                                                                    fontWeight: 600,
                                                                    lineHeight: 'inherit',
                                                                    whiteSpace: 'nowrap',
                                                                    border: 'none',
                                                                    cursor: 'pointer',
                                                                    ...boxshadowHover
                                                                }
                                                                : {
                                                                    ...statusLabel,
                                                                    backgroundColor: statusColors[document.statusString] || "inherit",
                                                                    color: 'black',
                                                                    fontSize: '10px',
                                                                    fontWeight: 600,
                                                                    lineHeight: 'inherit',
                                                                    whiteSpace: 'nowrap',
                                                                    border: 'none',
                                                                    cursor: 'pointer',
                                                                    ...boxshadowUnHover({})
                                                                }
                                                        }
                                                    >
                                                        {document.statusString}
                                                    </button>
                                                ) : document.statusId === 7 ? (
                                                    /* Non-admin view of Mapping Needed: static "Mapping" label with a
                                                       visible info icon + instant CSS popup (same pattern as Exception),
                                                       since the admin still owns finishing the account mapping. */
                                                    <span className="dc-inline-tip" style={{ cursor: 'default' }}>
                                                        <label
                                                            style={{
                                                                ...statusLabel,
                                                                backgroundColor: statusColors[document.statusString] || "inherit"
                                                            }}
                                                        >
                                                            Mapping
                                                        </label>
                                                        <FontAwesomeIcon
                                                            icon={faCircleInfo}
                                                            style={{ marginLeft: 5, color: '#6b7280', width: 12, height: 12, verticalAlign: 'middle' }}
                                                        />
                                                        <span className="dc-inline-tip-text">Mapping of accounts in progress</span>
                                                    </span>
                                                ) : document.statusId === 4 && accountProfile.hasImpersonate && !document.isImtsAccount
                                                    && document.receivedDate && new Date(document.receivedDate).setHours(0, 0, 0, 0) > EXCEPTION_ACTION_CUTOFF_DATE.getTime() ? (
                                                    /* admin Exception pill: opens the delete/re-run dialog */
                                                    <button
                                                        type="button"
                                                        title="Click to delete or re-run"
                                                        onClick={() => handleOpenExceptionAction(document.statementId, document.statementIdString)}
                                                        onMouseEnter={() => setHoveredBtn({ index, type: 'exceptionAction' })}
                                                        onMouseLeave={() => setHoveredBtn(null)}
                                                        style={
                                                            hoveredBtn?.index === index && hoveredBtn?.type === 'exceptionAction'
                                                                ? {
                                                                    ...statusLabel,
                                                                    backgroundColor: statusColors[document.statusString] || "inherit",
                                                                    color: 'black',
                                                                    fontSize: '10px',
                                                                    fontWeight: 600,
                                                                    lineHeight: 'inherit',
                                                                    whiteSpace: 'nowrap',
                                                                    border: 'none',
                                                                    cursor: 'pointer',
                                                                    ...boxshadowHover
                                                                }
                                                                : {
                                                                    ...statusLabel,
                                                                    backgroundColor: statusColors[document.statusString] || "inherit",
                                                                    color: 'black',
                                                                    fontSize: '10px',
                                                                    fontWeight: 600,
                                                                    lineHeight: 'inherit',
                                                                    whiteSpace: 'nowrap',
                                                                    border: 'none',
                                                                    cursor: 'pointer',
                                                                    ...boxshadowUnHover({})
                                                                }
                                                        }
                                                    >
                                                        {document.statusString}
                                                    </button>
                                                ) : document.statusId === 4 ? (
                                                    /* Exception: visible info icon as a "there's more here" cue, plus the
                                                       same instant CSS tooltip (hovering the pill or the icon shows it). */
                                                    <span className="dc-inline-tip" style={{ cursor: 'default' }}>
                                                        <label
                                                            style={{
                                                                ...statusLabel,
                                                                backgroundColor: statusColors[document.statusString] || "inherit"
                                                            }}
                                                        >
                                                            {document.statusString}
                                                        </label>
                                                        <FontAwesomeIcon
                                                            icon={faCircleInfo}
                                                            style={{ marginLeft: 5, color: '#6b7280', width: 12, height: 12, verticalAlign: 'middle' }}
                                                        />
                                                        <span className="dc-inline-tip-text">Support has been Notified</span>
                                                    </span>
                                                ) : (
                                                    <label
                                                        style={{
                                                            ...statusLabel,
                                                            backgroundColor: statusColors[document.statusString] || "inherit"
                                                        }}
                                                    >
                                                        {document.statusString}
                                                    </label>
                                                )}
                                            </td>
                                            {/*GROUP DOWNLOAD checkbox — only enabled when status is Available(2) or Downloaded(3)*/}
                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                {(() => {
                                                    const canBatch = document.statusId === 2 || document.statusId === 3;
                                                    return (
                                                        <input
                                                            type="checkbox"
                                                            style={{ width: 18, height: 18, cursor: canBatch ? 'pointer' : 'not-allowed' }}
                                                            disabled={!canBatch}
                                                            checked={isSelected(document.statementId, document.sequenceNumber)}
                                                            onChange={() => toggleSelection(document)}
                                                            aria-label="Select row for group download"
                                                        />
                                                    );
                                                })()}
                                            </td>

                                            {/*SOURCE / EXCEL / CDEX BUTTONS*/}
                                            <td>
                                                {(() => {
                                                        //Excel/CDEX enable + routing rules:
                                                        //  - Status must be Available(2), Downloaded(3) or Duplicate(8) - a duplicate is a
                                                        //    fully processed conversion and stays downloadable.
                                                        //  - Excel: Revenue(1) or JIB(2); also allowed while Mapping Needed(7).
                                                        //  - CDEX: Revenue(1), and account output type == 2 (CDEX).
                                                        //  - DataFileId null  -> legacy handleBlobDownload.
                                                        //  - DataFileId set   -> api/a_export/*ByStatement.
                                                        const statusReady = document.statusId === 2 || document.statusId === 3 || document.statusId === 8;
                                                        const statusExcelReady = statusReady || document.statusId === 7;
                                                        const isRevenue = document.statementTypeId === 1;
                                                        const isJib = document.statementTypeId === 2;
                                                        const hasDataFile = document.dataFileId != null;
                                                        const isCdexAccount = docConversionOutputType === 2;
                                                        const isImtsAccount = docConversionNetworkType === 1;
                                                        //request rows (sequence 0) offer only the source PDF
                                                        const isRequestRow = document.sequenceNumber === 0;
                                                        const accountShowsCdex = isCdexAccount || isImtsAccount;
                                                        const accountShowsExcel = !isImtsAccount;
                                                        const showCdex = accountShowsCdex && !isRequestRow;
                                                        const showExcel = accountShowsExcel && !isRequestRow;
                                                        //keep the lone PDF button the same width it has beside its usual siblings
                                                        const resultRowButtonCount = 1 + (accountShowsExcel ? 1 : 0) + (accountShowsCdex ? 1 : 0);
                                                        const requestRowPdfWidth = isRequestRow ? { maxWidth: `calc(${100 / resultRowButtonCount}% - 6px)` } : {};

                                                        const excelEnabled = statusExcelReady && (isRevenue || isJib) && showExcel;
                                                        const cdexEnabled = statusReady && isRevenue && showCdex;


                                                        const handleExcelClick = () => {
                                                            if (!isDev) return;
                                                            if (!hasDataFile) {
                                                                handleBlobDownload(document.statementId, document.sequenceNumber);
                                                            } else if (isRevenue) {
                                                                handleStatementExport(document.statementId, document.sequenceNumber, 'excel', document.inputFileName);
                                                            } else if (isJib) {
                                                                handleStatementExport(document.statementId, document.sequenceNumber, 'jib', document.inputFileName);
                                                            }
                                                        };

                                                        const handleCdexClick = () => {
                                                            if (!isDev) return;
                                                            if (!hasDataFile) {
                                                                handleBlobDownload(document.statementId, document.sequenceNumber);
                                                            } else {
                                                                handleStatementExport(document.statementId, document.sequenceNumber, 'cdex', document.inputFileName);
                                                            }
                                                        };

                                                        return (
                                                            <>
                                                                <div className="d-flex flex-column flex-md-row">
                                                                    <Button
                                                                        style={
                                                                            hoveredBtn?.index === index && hoveredBtn?.type === 'pdf'
                                                                                ? { ...sourceDataBtn, ...boxshadowHover, marginLeft: "0px", marginRight: "6px", whiteSpace: 'nowrap', padding: '5px 4px', fontSize: '0.55rem', lineHeight: 1.2, letterSpacing: 0, fontFamily: 'inherit', ...requestRowPdfWidth }
                                                                                : { ...sourceDataBtn, ...boxshadowUnHover(sourceDataBtn), marginLeft: "0px", marginRight: "6px", whiteSpace: 'nowrap', padding: '5px 4px', fontSize: '0.55rem', lineHeight: 1.2, letterSpacing: 0, fontFamily: 'inherit', ...requestRowPdfWidth }
                                                                        }
                                                                        onMouseEnter={() => setHoveredBtn({ index, type: 'pdf' })}
                                                                        onMouseLeave={() => setHoveredBtn(null)}
                                                                        size="sm"
                                                                        className="w-100 w-md-auto"
                                                                        value={document.id}
                                                                        onClick={!isDev ? null : () => handleBlobDownload(document.statementId, 0)}
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowDown} style={{ ...faIconStyle(faArrowDown), width: 6, height: 6 }} />
                                                                        <br />PDF
                                                                    </Button>
                                                                    {showExcel && (
                                                                        <Button
                                                                            style={
                                                                                hoveredBtn?.index === index && hoveredBtn?.type === 'excel'
                                                                                    ? { ...sourceDataBtn, ...boxshadowHover, marginLeft: "0px", marginRight: "6px", whiteSpace: 'nowrap', padding: '5px 4px', fontSize: '0.55rem', lineHeight: 1.2, letterSpacing: 0, fontFamily: 'inherit' }
                                                                                    : { ...sourceDataBtn, ...boxshadowUnHover(sourceDataBtn), marginLeft: "0px", marginRight: "6px", whiteSpace: 'nowrap', padding: '5px 4px', fontSize: '0.55rem', lineHeight: 1.2, letterSpacing: 0, fontFamily: 'inherit' }
                                                                            }
                                                                            onMouseEnter={() => setHoveredBtn({ index, type: 'excel' })}
                                                                            onMouseLeave={() => setHoveredBtn(null)}
                                                                            variant="primary"
                                                                            size="sm"
                                                                            className="w-100 w-md-auto"
                                                                            value={document.id}
                                                                            disabled={!excelEnabled}
                                                                            onClick={excelEnabled ? handleExcelClick : null}
                                                                        >
                                                                            <FontAwesomeIcon icon={faArrowDown} style={{ ...faIconStyle(faArrowDown), width: 6, height: 6 }} />
                                                                            <br />Excel
                                                                        </Button>
                                                                    )}
                                                                    {showCdex && (
                                                                        <Button
                                                                            style={
                                                                                hoveredBtn?.index === index && hoveredBtn?.type === 'cdex'
                                                                                    ? { ...sourceDataBtn, ...boxshadowHover, marginLeft: "0px", marginRight: "6px", whiteSpace: 'nowrap', padding: '5px 4px', fontSize: '0.55rem', lineHeight: 1.2, letterSpacing: 0, fontFamily: 'inherit' }
                                                                                    : { ...sourceDataBtn, ...boxshadowUnHover(sourceDataBtn), marginLeft: "0px", marginRight: "6px", whiteSpace: 'nowrap', padding: '5px 4px', fontSize: '0.55rem', lineHeight: 1.2, letterSpacing: 0, fontFamily: 'inherit' }
                                                                            }
                                                                            onMouseEnter={() => setHoveredBtn({ index, type: 'cdex' })}
                                                                            onMouseLeave={() => setHoveredBtn(null)}
                                                                            variant="primary"
                                                                            size="sm"
                                                                            className="w-100 w-md-auto"
                                                                            value={document.id}
                                                                            disabled={!cdexEnabled}
                                                                            onClick={cdexEnabled ? handleCdexClick : null}
                                                                        >
                                                                            <FontAwesomeIcon icon={faArrowDown} style={{ ...faIconStyle(faArrowDown), width: 6, height: 6 }} />
                                                                            <br />CDEX
                                                                        </Button>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )
                                                })()}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colspan={13} className="text-center py-3">
                                            <span className="fs-5">
                                                <em>No results found</em>
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Row>
            </Container>
        );
    }

    //render component
    return (
        <div>
            <Alert variant={alertVariant} show={alertShow} onClose={() => setAlertShow(false)} dismissible>
                {alertMessage}
            </Alert>
            <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1a2a3a', marginTop: '-20px', marginBottom: '4px', textAlign: 'center' }} hidden={alertShow}>Document Conversion</p>
            {(() => {
                switch (pageStatus) {
                    case 'loading':
                        return showPageLoading()
                    case 'ready':
                        return showTableContainer()
                    case 'error':
                        return showPageError()
                    default:
                        return <p>No Page Loaded.</p>
                }
            })()}

            <DocumentInputModal
                show={documentInputModalShow}
                onHide={() => setDocumentInputModalShow(false)}
                onAddCategory={() => setCategoryAddModalShow(true)}
                newItemCriteria={newItemCriteria}
                setNewItemCriteria={setNewItemCriteria}
                statementTypes={statementTypes.filter(t => t.type != 'All')}
                deliveryTimes={deliveryTimes.filter(t => t.time != 'All')}
                statementCategories={statementCategories}
                handleInputChange={handleInputChange}
                isEmailValid={isEmailValid}
                docConversionNetworkType={docConversionNetworkType}
                handlefileInputChange={handleDrop}
                handleDrop={handleDrop}
                handleBlobUpload={isDev ? handleBlobUpload : handleFileUpload}
                uploadFiles={uploadFiles}
                handleRemoveFile={handleRemoveFile}
                handleDragEnter={handleDragEnter}
                handleDragLeave={handleDragLeave}
                dragging={dragging}
            />

            <NoDocConversionMessageModal
                show={noDocConversionModalShow}
                onHide={() => setNoDocConversionModalShow(false)}
                onNext={() => setNoDocConversionModalShow(true)}
            />

            <CategoryAddModal
                show={categoryAddModalShow}
                onHide={() => setCategoryAddModalShow(false)}
                newCategory={newCategory}
                setNewCategory={setNewCategory}
                statementCategories={statementCategories}
                handleCategoryInputChange={handleCategoryInputChange}
                handleAddCategory={handleAddCategory}
                isCategoryCodeValid={isCategoryCodeValid}
                isCategoryNameValid={isCategoryNameValid}
            />
            
            <CategoryChangeConfirmationModal
                show={categoryChangeConfirmationModalShow}
                onHide={() => setCategoryChangeConfirmationModalShow(false)}
                categoryChangeCriteria={categoryChangeCriteria}
                saveItemCategoryChange={saveItemCategoryChange}
            />

            {/* Mapping Needed popup. Triggered from the status pill on
                Mapping Needed rows. */}
            <MappingNeededModal
                show={mappingNeededModalShow}
                onHide={() => setMappingNeededModalShow(false)}
                statementIdString={mappingNeededStatementIdString}
                loading={mappingNeededLoading}
                error={mappingNeededError}
                data={mappingNeededData}
                senderCodeInput={senderCodeInput}
                setSenderCodeInput={setSenderCodeInput}
                productMappings={productMappings}
                setProductMappings={setProductMappings}
                transactionMappings={transactionMappings}
                setTransactionMappings={setTransactionMappings}
                savingSenderCode={savingSenderCode}
                savingCdexCodes={savingCdexCodes}
                onSaveSenderCode={handleSaveSenderCode}
                onSaveCdexCodes={handleSaveCdexCodes}
                hasImpersonate={accountProfile.hasImpersonate}
                revLineTypeOptions={[
                    { code: '', value: '' },
                    { code: 'R', value: 'REV' },
                    { code: 'T', value: 'TAX' },
                    { code: 'D', value: 'DED' },
                    { code: 'N', value: 'NET' }
                ]}
            />

            {/* Exception delete/re-run popup */}
            <ExceptionActionModal
                show={exceptionActionModalShow}
                onHide={() => setExceptionActionModalShow(false)}
                statementIdString={exceptionActionStatementIdString}
                busyAction={exceptionActionBusy}
                completedAction={exceptionActionCompleted}
                error={exceptionActionError}
                warning={exceptionActionWarning}
                successMessage={exceptionActionSuccess}
                confirmingDelete={exceptionConfirmingDelete}
                setConfirmingDelete={setExceptionConfirmingDelete}
                onDelete={() => runExceptionAction('delete')}
                onRerun={() => runExceptionAction('rerun')}
            />
        </div>
    );
}

export default DocumentConversion;
